<div theme>
  <div class="progess-spinner-overlay" *ngIf="isLoaderEnabled">
    <div class="progess-spinner-center">
      <div class="loader">Loading...</div>
    </div>
    <div class="progess-spinner-center-text">
      Saving files might take a while. Do not refresh/reload the screen
    </div>
  </div>
  <div class="onboard-create-wrapper">
    <form class="form-gap-style" [formGroup]="onboardCreateForm" (keydown.enter)="$event.preventDefault()">
      <div fxLayout="column" fxLayoutGap="1%" class="viewContent">
        <div fxLayout="row">
          <div fxFlex="100%">
            <div *ngIf="formIndex === 1">
              <div>
                <!-- Identity Tab  -->
                <!-- *ngIf="orgBasedOnboardFormsJson.identityFinFieldIsActive" -->
                <!-- label="{{orgBasedOnboardFormsJson.identityFinFieldDisplayName}}" -->
                <div class="subtitle-wrapper additional-title-wrapper" fxLayout="row"
                  fxLayoutAlign="space-between center">
                  <p class="section-title personal-title"> Additional Info </p>
                  <div fxLayout="row" fxLayoutAlign="end center" class="enter-button-wrapper">
                    <button (click)="cancelOnboardEdit();" mat-stroked-button type="button"
                      class="edit-button cancel-button" *ngIf="editable">
                      <mat-icon>close</mat-icon>
                      <span class="icon-content">Cancel</span>
                    </button>
                    <!-- *ngIf="!editable && JWTPrivilegesArray.includes('ONBOARD_EDIT_ACECSS') " -->
                    <button *ngIf="!editable" mat-raised-button class="edit-button" (click)="enableEdit()">
                      <mat-icon>edit</mat-icon>
                      <span class="icon-content">Edit</span>
                    </button>

                    <button type="submit" (click)="submit()" mat-button *ngIf="editable"
                      class="plain-core-button edit-button" [disabled]="!onboardCreateForm.dirty">
                      <mat-icon>save</mat-icon>
                      <span class="icon-content">
                        Update
                      </span>
                    </button>

                  </div>
                </div>
                <div class="additional-container">
                  <mat-card class="section-card">
                    <!-- *ngIf="orgBasedOnboardFormsJson.identityFieldIsActive" -->
                    <div class="identity-field-container">
                      <!-- {{orgBasedOnboardFormsJson.identityFieldDisplayName}} -->
                      <div class="onboard-subtitle">Identity</div>
                      <div fxLayout="row" formGroupName="identity" fxLayoutAlign="start center" class="identy-wrapper">
                        <!-- pancard  -->
                        <!-- *ngIf="orgBasedOnboardFormsJson.pancardFieldIsActive" -->
                        <div fxFlex="25%">
                          <mat-form-field class="bank-name formField-height">
                            <!-- {{orgBasedOnboardFormsJson.pancardFieldDisplayName}} -->
                            <mat-label>Taxpayer ID No.</mat-label>
                            <!-- [required]="orgBasedOnboardFormsJson.pancardFieldIsRequired" -->
                            <input (keydown)="inputSpaceRestrict($event)" matInput autocomplete="off"
                              formControlName="pancard_no">
                            <mat-error
                              *ngIf="onboardCreateForm.controls.identity.get('pancard_no').hasError('required')">
                              <strong>Required</strong>
                            </mat-error>
                            <mat-error
                              *ngIf="onboardCreateForm.controls.identity.get('pancard_no').hasError('pattern')">
                              <strong>Invalid Format</strong>
                            </mat-error>
                            <mat-error
                              *ngIf="onboardCreateForm.controls.identity.get('pancard_no').hasError('maxlength')">
                              <strong>Exceeds Max Limit</strong>
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <!-- ssn  -->
                        <!-- *ngIf="orgBasedOnboardFormsJson.ssnFieldIsActive" -->
                        <div fxFlex="25%">
                          <mat-form-field class="formField-height bank-name ">
                            <!-- {{orgBasedOnboardFormsJson.ssnFieldDisplayName}} -->
                            <mat-label>Social Security No.</mat-label>
                            <!-- [required]="orgBasedOnboardFormsJson.ssnFieldIsRequired" -->
                            <input (keydown)="inputSpaceRestrict($event)" matInput autocomplete="off"
                              formControlName="ssn_no">
                            <mat-error *ngIf="onboardCreateForm.controls.identity.get('ssn_no').hasError('required')">
                              <strong>Required</strong>
                            </mat-error>
                            <mat-error *ngIf="onboardCreateForm.controls.identity.get('ssn_no').hasError('pattern')">
                              <strong>Invalid Format</strong>
                            </mat-error>
                            <mat-error *ngIf="onboardCreateForm.controls.identity.get('ssn_no').hasError('maxlength')">
                              <strong>Exceeds Max Limit</strong>
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <!-- passport  -->
                        <!-- *ngIf="orgBasedOnboardFormsJson.passportFieldIsActive" -->
                        <div fxFlex="25%">
                          <mat-form-field class="formField-height bank-name">
                            <!-- {{orgBasedOnboardFormsJson.passportFieldDisplayName}} -->
                            <mat-label>Passport No.</mat-label>
                            <!-- [required]="orgBasedOnboardFormsJson.passportFieldIsRequired" -->
                            <input (keydown)="inputSpaceRestrict($event)" matInput autocomplete="off"
                              formControlName="passport_no">
                            <mat-error
                              *ngIf="onboardCreateForm.controls.identity.get('passport_no').hasError('required')">
                              <strong>Required</strong>
                            </mat-error>
                            <mat-error
                              *ngIf="onboardCreateForm.controls.identity.get('passport_no').hasError('pattern')">
                              <strong>Invalid Format</strong>
                            </mat-error>
                            <mat-error
                              *ngIf="onboardCreateForm.controls.identity.get('passport_no').hasError('maxlength')">
                              <strong>Exceeds Max Limit</strong>
                            </mat-error>
                          </mat-form-field>
                        </div>
                        <!-- license  -->
                        <!-- *ngIf="orgBasedOnboardFormsJson.drivinglicenseFieldIsActive" -->
                        <div fxFlex="25%">
                          <mat-form-field class="formField-height bank-name">
                            <!-- {{orgBasedOnboardFormsJson.drivinglicenseFieldDisplayName}} -->
                            <mat-label>Driving License No.</mat-label>
                            <!-- [required]="orgBasedOnboardFormsJson.drivinglicenseFieldIsRequired" -->
                            <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="drivinglicense_no"
                              autocomplete="off">
                            <mat-error
                              *ngIf="onboardCreateForm.controls.identity.get('drivinglicense_no').hasError('required')">
                              <strong>Required</strong>
                            </mat-error>
                            <mat-error
                              *ngIf="onboardCreateForm.controls.identity.get('drivinglicense_no').hasError('pattern')">
                              <strong>Invalid Format</strong>
                            </mat-error>
                            <mat-error
                              *ngIf="onboardCreateForm.controls.identity.get('drivinglicense_no').hasError('maxlength')">
                              <strong>Exceeds Max Limit</strong>
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                    <!-- Bank details  -->
                    <!-- *ngIf="orgBasedOnboardFormsJson.bankdetailsFieldIsActive" -->
                    <div style="margin-top: 2%;" class="identity-field-container">
                      <!-- {{orgBasedOnboardFormsJson.bankdetailsFieldDisplayName}} -->
                      <div class="onboard-subtitle">Financial Details</div>
                      <div formGroupName="bank">
                        <div fxLayout="row" fxLayoutAlign="start center" class="financial-container">
                          <!-- *ngIf="orgBasedOnboardFormsJson.banknameFieldIsActive" -->
                          <div fxFlex="25%">
                            <mat-form-field class="formField-height bank-name">
                              <!-- {{orgBasedOnboardFormsJson.banknameFieldDisplayName}} -->
                              <mat-label>Bank</mat-label>
                              <!-- [required]="orgBasedOnboardFormsJson.banknameFieldIsRequired" -->
                              <!-- <mat-select formControlName="bankname_1">
                                <mat-option value="Bank of America">Bank of America</mat-option>
                                <mat-option value="HSBC">HSBC</mat-option>
                                <mat-option value="CITIGROUP INC">CITIGROUP INC</mat-option>
                              </mat-select> -->
                              <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="bankname_1"
                                autocomplete="off">
                              <mat-error *ngIf="onboardCreateForm.controls.bank.get('bankname_1').hasError('required')">
                                <strong>Required</strong>
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <!-- *ngIf="orgBasedOnboardFormsJson.bankaccnoFieldIsActive" -->
                          <div fxFlex="25%">
                            <mat-form-field class="formField-height bank-name">
                              <!-- {{orgBasedOnboardFormsJson.bankaccnoFieldDisplayName}} -->
                              <mat-label>Bank A/C No.</mat-label>
                              <!-- [required]="orgBasedOnboardFormsJson.bankaccnoFieldIsRequired" autocomplete="off" -->
                              <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="bankaccountno_1">
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('bankaccountno_1').hasError('required')">
                                <strong>Required</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('bankaccountno_1').hasError('pattern')">
                                <strong>Invalid Format</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('bankaccountno_1').hasError('minlength')">
                                <strong>Minimum 5 Characters is Required</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('bankaccountno_1').hasError('maxlength')">
                                <strong>Exceeds Max Limit</strong>
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <!-- *ngIf="orgBasedOnboardFormsJson.bankifscFieldIsActive" -->
                          <div fxFlex="25%">
                            <mat-form-field class="formField-height bank-name">
                              <!-- {{orgBasedOnboardFormsJson.bankifscFieldDisplayName}} -->
                              <mat-label>SWIFT/IBAN</mat-label>
                              <!-- [required]="orgBasedOnboardFormsJson.bankifscFieldIsRequired" -->
                              <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="ifsc_code_1"
                                autocomplete="off">
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('ifsc_code_1').hasError('required')">
                                <strong>Required</strong>
                              </mat-error>
                              <mat-error *ngIf="onboardCreateForm.controls.bank.get('ifsc_code_1').hasError('pattern')">
                                <strong>Invalid Format</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('ifsc_code_1').hasError('maxlength')">
                                <strong>Exceeds Max Limit</strong>
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <!-- bank 2  -->
                        <div fxLayout="row" fxLayoutAlign="start center" class="financial-container">
                          <!-- *ngIf="orgBasedOnboardFormsJson.banknameFieldIsActive" -->
                          <div fxFlex="25%">
                            <mat-form-field class="formField-height bank-name">
                              <!-- {{orgBasedOnboardFormsJson.banknameFieldDisplayName}} -->
                              <mat-label>Bank</mat-label>
                              <!-- [required]="orgBasedOnboardFormsJson.banknameFieldIsRequired" -->
                              <!-- <mat-select formControlName="bankname_2">
                                <mat-option value="Bank of America">Bank of America</mat-option>
                                <mat-option value="HSBC">HSBC</mat-option>
                                <mat-option value="CITIGROUP INC">CITIGROUP INC</mat-option>
                              </mat-select> -->
                              <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="bankname_2"
                                autocomplete="off">
                              <mat-error *ngIf="onboardCreateForm.controls.bank.get('bankname_2').hasError('required')">
                                <strong>Required</strong>
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <!-- *ngIf="orgBasedOnboardFormsJson.bankaccnoFieldIsActive" -->
                          <div fxFlex="25%">
                            <mat-form-field class="formField-height bank-name">
                              <!-- {{orgBasedOnboardFormsJson.bankaccnoFieldDisplayName}} -->
                              <mat-label>Bank A/C No.</mat-label>
                              <!-- [required]="orgBasedOnboardFormsJson.bankaccnoFieldIsRequired" -->
                              <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="bankaccountno_2"
                                autocomplete="off">
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('bankaccountno_2').hasError('required')">
                                <strong>Required</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('bankaccountno_2').hasError('pattern')">
                                <strong>Invalid Format</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('bankaccountno_2').hasError('minlength')">
                                <strong>Minimum 5 Characters is Required</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('bankaccountno_2').hasError('maxlength')">
                                <strong>Exceeds Max Limit</strong>
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <!-- *ngIf="orgBasedOnboardFormsJson.bankifscFieldIsActive" -->
                          <div fxFlex="25%">
                            <mat-form-field class="formField-height bank-name">
                              <!-- {{orgBasedOnboardFormsJson.bankifscFieldDisplayName}} -->
                              <mat-label>SWIFT/IBAN</mat-label>
                              <!-- [required]="orgBasedOnboardFormsJson.bankifscFieldIsRequired" -->
                              <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="ifsc_code_2"
                                autocomplete="off">
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('ifsc_code_2').hasError('required')">
                                <strong>Required</strong>
                              </mat-error>
                              <mat-error *ngIf="onboardCreateForm.controls.bank.get('ifsc_code_2').hasError('pattern')">
                                <strong>Invalid Format</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('ifsc_code_2').hasError('maxlength')">
                                <strong>Exceeds Max Limit</strong>
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <!-- bank 3  -->
                        <div fxLayout="row" fxLayoutAlign="start center" class="financial-container">
                          <!-- *ngIf="orgBasedOnboardFormsJson.banknameFieldIsActive" -->
                          <div fxFlex="25%">
                            <mat-form-field class="formField-height bank-name">
                              <!-- {{orgBasedOnboardFormsJson.banknameFieldDisplayName}} -->
                              <mat-label>Bank</mat-label>
                              <!-- [required]="orgBasedOnboardFormsJson.banknameFieldIsRequired" -->
                              <!-- <mat-select formControlName="bankname_3">
                                <mat-option value="Bank of America">Bank of America</mat-option>
                                <mat-option value="HSBC">HSBC</mat-option>
                                <mat-option value="CITIGROUP INC">CITIGROUP INC</mat-option>
                              </mat-select> -->
                              <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="bankname_3"
                                autocomplete="off">
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('bankaccountno_3').hasError('required')">
                                <strong>Required</strong>
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <!-- *ngIf="orgBasedOnboardFormsJson.bankaccnoFieldIsActive" -->
                          <div fxFlex="25%">
                            <mat-form-field class="formField-height bank-name">
                              <!-- {{orgBasedOnboardFormsJson.bankaccnoFieldDisplayName}} -->
                              <mat-label>Bank A/C No.</mat-label>
                              <!-- [required]="orgBasedOnboardFormsJson.bankaccnoFieldIsRequired" autocomplete="off" -->
                              <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="bankaccountno_3">
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('bankaccountno_3').hasError('required')">
                                <strong>Required</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('bankaccountno_3').hasError('pattern')">
                                <strong>Invalid Format</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('bankaccountno_3').hasError('minlength')">
                                <strong>Minimum 5 Characters is Required</strong>
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <!-- *ngIf="orgBasedOnboardFormsJson.bankifscFieldIsActive" -->
                          <div fxFlex="25%">
                            <mat-form-field class="formField-height bank-name">
                              <!-- {{orgBasedOnboardFormsJson.bankifscFieldDisplayName}} -->
                              <mat-label>SWIFT/IBAN</mat-label>
                              <!-- [required]="orgBasedOnboardFormsJson.bankifscFieldIsRequired" autocomplete="off" -->
                              <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="ifsc_code_3">
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('ifsc_code_3').hasError('required')">
                                <strong>Required</strong>
                              </mat-error>
                              <mat-error *ngIf="onboardCreateForm.controls.bank.get('ifsc_code_3').hasError('pattern')">
                                <strong>Invalid Format</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.bank.get('ifsc_code_3').hasError('maxlength')">
                                <strong>Exceeds Max Limit</strong>
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-card>
                  <!-- References tab  -->
                  <!-- *ngIf="orgBasedOnboardFormsJson.referencesFieldIsActive" -->
                  <!-- label="{{orgBasedOnboardFormsJson.referencesFieldDisplayName}}" -->
                  <mat-card class="section-card">
                    <div class="subtitle-wrapper no-content-added" fxLayout="row" fxLayoutAlign="space-between center">
                      <p class="section-title personal-title">References</p>
                      <button class="add-btn" type="button" mat-stroked-button placeholder="Add"
                        [disabled]="!editable || reference.length == 5" (click)="addFieldValueReference()"
                        [class.delete-button-mobile]="reference.length < 5 && editable == true" style="margin: 1%;">
                        <mat-icon>add</mat-icon>
                        <span class="icon-content">Add</span>
                      </button>
                    </div>
                    <div class="no-content-container" style="margin: 0% 1%;"
                      [class.no-content]="onboardCreateForm['controls'].reference['controls'].length !== 0">
                      <div>
                        References - Details Not Provided.
                      </div>
                    </div>
                    <div (keydown.enter)="$event.preventdefault()" style="margin-top: 10px;"
                      class="identity-field-container">
                      <div formArrayName="reference"
                        *ngFor="let data of onboardCreateForm['controls'].reference['controls'];let i = index"
                        class="reference-tab" fxLayout="row" fxLayoutAlign="start center">
                        <div [formGroupName]="i" fxLayout="row" fxLayoutAlign="space-around center"
                          class="references-wrapper" style="margin-bottom: 14px;">
                          <div fxLayout="row" fxLayoutAlign="space-between center" class="reference-name-wrapper">
                            <div class="candidate-details-number">
                              {{i+1}}
                            </div>
                            <mat-form-field class="education formField-height reference-name-field">
                              <mat-label>Name</mat-label>
                              <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="name"
                                autocomplete="off">
                              <mat-error
                                *ngIf="onboardCreateForm.controls.reference.controls[i].get('name').hasError('required')">
                                <strong>Required</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.reference.controls[i].get('name').hasError('email')">
                                <strong>Invalid Format</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.reference.controls[i].get('name').hasError('maxlength')">
                                <strong>Exceeds Max Limit</strong>
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <mat-form-field class="education formField-height reference-field">
                            <mat-label>Designation</mat-label>
                            <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="designation"
                              autocomplete="off">
                            <mat-error
                              *ngIf="onboardCreateForm.controls.reference.controls[i].get('designation').hasError('required')">
                              <strong>Required</strong>
                            </mat-error>
                            <mat-error
                              *ngIf="onboardCreateForm.controls.reference.controls[i].get('designation').hasError('pattern')">
                              <strong>Invalid Format</strong>
                            </mat-error>
                            <mat-error
                              *ngIf="onboardCreateForm.controls.reference.controls[i].get('designation').hasError('maxlength')">
                              <strong>Exceeds Max Limit</strong>
                            </mat-error>
                          </mat-form-field>
                          <mat-form-field class="education formField-height reference-field">
                            <mat-label>Organization</mat-label>
                            <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="organization"
                              autocomplete="off">
                            <mat-error
                              *ngIf="onboardCreateForm.controls.reference.controls[i].get('organization').hasError('required')">
                              <strong>Required</strong>
                            </mat-error>
                            <mat-error
                              *ngIf="onboardCreateForm.controls.reference.controls[i].get('organization').hasError('pattern')">
                              <strong>Invalid Format</strong>
                            </mat-error>
                            <mat-error
                              *ngIf="onboardCreateForm.controls.reference.controls[i].get('organization').hasError('maxlength')">
                              <strong>Exceeds Max Limit</strong>
                            </mat-error>
                          </mat-form-field>
                          <mat-form-field class="education formField-height reference-field">
                            <mat-label>Relation Type</mat-label>
                            <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="relationtype"
                              autocomplete="off">
                            <mat-error
                              *ngIf="onboardCreateForm.controls.reference.controls[i].get('relationtype').hasError('required')">
                              <strong>Required</strong>
                            </mat-error>
                            <mat-error
                              *ngIf="onboardCreateForm.controls.reference.controls[i].get('relationtype').hasError('pattern')">
                              <strong>Invalid Format</strong>
                            </mat-error>
                            <mat-error
                              *ngIf="onboardCreateForm.controls.reference.controls[i].get('relationtype').hasError('maxlength')">
                              <strong>Exceeds Max Limit</strong>
                            </mat-error>
                          </mat-form-field>
                          <div fxLayout="row" class="reference-field" fxLayoutGap="3%"
                            fxLayoutAlign="space-between center">
                            <mat-form-field
                              class="application-form-field salutation-form-field formField-height reference-code">
                              <mat-label>Code</mat-label>
                              <mat-select (click)="refdialcodeSearch.value = ''"
                                (opened)="focusInput('refdialcodeSearch')"
                                (selectionChange)="appendPhoneNumberForFormArray('dialcode', 'mobilenumber', 'contact', 'reference', i)"
                                formControlName="dialcode">
                                <mat-icon class="code-search">search</mat-icon>
                                <input (keydown)="inputSpaceRestrict($event)" #refdialcodeSearch matInput
                                  class="search-country" placeholder="Search country">
                                <!-- (keypress)="textOnlyKeyPress($event)"  -->
                                <!-- <mat-select-trigger>
                                  {{ onboardCreateForm.controls.reference.controls[i].get('dialcode').value }}
                                </mat-select-trigger> -->
                                <mat-option
                                  *ngFor="let refdialCode of dialCodes | dialoCodeFilter:refdialcodeSearch.value"
                                  [value]='refdialCode.code'>
                                  {{refdialCode.code}} -
                                  {{refdialCode.name}}
                                </mat-option>
                              </mat-select>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.reference.controls[i].get('dialcode').hasError('required')">
                                <strong>Required</strong>
                              </mat-error>
                            </mat-form-field>
                            <!-- Mobile Number -->
                            <mat-form-field
                              (change)="appendPhoneNumberForFormArray('dialcode', 'mobilenumber', 'contact', 'reference', i)"
                              class="application-form-field firstname-form-field formField-height reference-mobile">
                              <mat-label>Mobile number</mat-label>
                              <input (keydown)="inputSpaceRestrict($event)" matInput type="text"
                                (keypress)="keyPressnumberonly($event)" #refmobileno formControlName="mobilenumber"
                                name="mobilenumber" autocomplete="off">
                              <mat-hint align="end">{{refmobileno.value.length}}</mat-hint>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.reference.controls[i].get('mobilenumber').hasError('required')">
                                <strong>Required</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.reference.controls[i].get('mobilenumber').hasError('pattern')">
                                <strong>Invalid Format</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.reference.controls[i].get('mobilenumber').hasError('minlength')">
                                <strong>Minimum 4 Characters is Required</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.reference.controls[i].get('mobilenumber').hasError('maxlength')">
                                <strong>Exceeds Max Limit</strong>
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div fxLayout="row" class="reference-field" fxLayoutAlign="space-between center">
                            <mat-form-field class="education formField-height reference-email">
                              <mat-label>Email</mat-label>
                              <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="email"
                                autocomplete="off">
                              <mat-error
                                *ngIf="onboardCreateForm.controls.reference.controls[i].get('email').hasError('required')">
                                <strong>Required</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.reference.controls[i].get('email').hasError('email')">
                                <strong>Invalid Format</strong>
                              </mat-error>
                              <mat-error
                                *ngIf="onboardCreateForm.controls.reference.controls[i].get('email').hasError('maxlength')">
                                <strong>Exceeds Max Limit</strong>
                              </mat-error>
                            </mat-form-field>
                            <button class="toolbar-icon-button" mat-button [disabled]="!editable"
                              [class.delete-icon-button]="onboardCreateForm.disabled == false"
                              [class.delete-icon-button-disabled]="onboardCreateForm.disabled == true"
                              (click)="deleteFieldValueReference(i)" matTooltip="Delete" style="margin-top: 15px;">
                              <mat-icon class="material-icons highlight-off-closeicon"
                                style="margin-right: 2.5px !important;">
                                highlight_off
                              </mat-icon>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-card>
                  <!-- Family  -->
                  <!-- *ngIf="orgBasedOnboardFormsJson.familyFieldIsActive" -->
                  <!-- label="{{orgBasedOnboardFormsJson.familyFieldDisplayName}}" -->
                  <mat-card class="section-card">
                    <div class="subtitle-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
                      <p class="section-title personal-title">Family Details</p>
                    </div>
                    <div>
                      <div style="margin: 0px 1%;">
                        <div formGroupName="family" style="margin-bottom: 2%;">
                          <div class="family-first-list" fxLayout="column">
                            <!-- Father -->
                            <!-- *ngIf="orgBasedOnboardFormsJson.fatherFieldIsActive" -->
                            <div fxLayout="row" fxLayoutAlign="start center" class="family-wrapper">
                              <div fxLayout="row" fxLayoutAlign="start center" class="family-parent">
                                <mat-form-field class="family-field formField-height">
                                  <mat-label>Father's Name</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="father_name"
                                    autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('father_name').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('father_name').hasError('pattern')">
                                    <strong>Invalid Format</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('father_name').hasError('maxlength')">
                                    <strong>Exceeds Max Limit</strong>
                                  </mat-error>
                                </mat-form-field>
                                <mat-form-field class="dob family-field formField-height">
                                  <mat-label>DOB</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="father_dob"
                                    [matDatepicker]="FatherDOB" readonly="readonly" autocomplete="off" [max]="maxDate">
                                  <mat-datepicker-toggle matSuffix [for]="FatherDOB"></mat-datepicker-toggle>
                                  <mat-datepicker #FatherDOB></mat-datepicker>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('father_dob').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div fxLayout="row" fxLayoutAlign="start center" class="family-parent">
                                <mat-form-field class="family-formfield formField-height family-field">
                                  <mat-label> Gender</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="father_gender"
                                    value="Male" [readonly]="true" autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('father_gender').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                </mat-form-field>
                                <mat-form-field class="family-formfield family-field formField-height">
                                  <mat-label> Address</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput
                                    formControlName="father_address" autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('father_address').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('father_address').hasError('pattern')">
                                    <strong>Invalid Format</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('father_address').hasError('maxlength')">
                                    <strong>Exceeds Max Limit</strong>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                            </div>
                            <!-- Mother  -->
                            <!-- *ngIf="orgBasedOnboardFormsJson.motherFieldIsActive" -->
                            <div fxLayout="row" fxLayoutAlign="start center" class="family-wrapper">
                              <div fxLayout="row" fxLayoutAlign="start center" class="family-parent">
                                <mat-form-field class="family-formfield family-field formField-height">
                                  <mat-label>Mother's Name</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="mother_name"
                                    autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('mother_name').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('mother_name').hasError('pattern')">
                                    <strong>Invalid Format</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('mother_name').hasError('maxlength')">
                                    <strong>Exceeds Max Limit</strong>
                                  </mat-error>
                                </mat-form-field>
                                <mat-form-field class="dob family-field formField-height">
                                  <mat-label>DOB</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="mother_dob"
                                    [matDatepicker]="MotherDOB" readonly="readonly" autocomplete="off" [max]="maxDate">
                                  <mat-datepicker-toggle matSuffix [for]="MotherDOB"></mat-datepicker-toggle>
                                  <mat-datepicker #MotherDOB></mat-datepicker>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('mother_dob').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div fxLayout="row" fxLayoutAlign="start center" class="family-parent">
                                <mat-form-field class="family-formfield family-field formField-height">
                                  <mat-label>Gender</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="mother_gender"
                                    value="Female" [readonly]="true" autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('mother_gender').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                </mat-form-field>
                                <mat-form-field class="family-formfield family-field formField-height">
                                  <mat-label>Address</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput
                                    formControlName="mother_address" autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('mother_address').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('mother_address').hasError('pattern')">
                                    <strong>Invalid Format</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('mother_address').hasError('maxlength')">
                                    <strong>Exceeds Max Limit</strong>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                            </div>
                            <!-- Spouse Name  -->
                            <!-- *ngIf="orgBasedOnboardFormsJson.spouseFieldIsActive" -->
                            <div fxLayout="row" fxLayoutAlign="start center" class="family-wrapper">
                              <div fxLayout="row" fxLayoutAlign="start center" class="family-parent">
                                <mat-form-field class="family-formfield family-field formField-height">
                                  <mat-label>Spouse Name</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="spouse_name"
                                    autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('spouse_name').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('spouse_name').hasError('pattern')">
                                    <strong>Invalid Format</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('spouse_name').hasError('maxlength')">
                                    <strong>Exceeds Max Limit</strong>
                                  </mat-error>
                                </mat-form-field>
                                <mat-form-field class="dob formField-height family-field">
                                  <mat-label>DOB</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="spouse_dob"
                                    [matDatepicker]="SpouseDOB" readonly="readonly" autocomplete="off" [max]="maxDate">
                                  <mat-datepicker-toggle matSuffix [for]="SpouseDOB"></mat-datepicker-toggle>
                                  <mat-datepicker #SpouseDOB></mat-datepicker>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('spouse_dob').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div fxLayout="row" fxLayoutAlign="start center" class="family-parent">
                                <mat-form-field class="family-formfield formField-height family-field">
                                  <mat-label>Gender</mat-label>
                                  <mat-select formControlName="spouse_gender" name="gender">
                                    <mat-option *ngFor="let gender of gender" [value]="gender.value">
                                      {{ gender.viewValue }}
                                    </mat-option>
                                  </mat-select>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('spouse_gender').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                </mat-form-field>
                                <mat-form-field class="family-formfield formField-height family-field">
                                  <mat-label>Address</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput
                                    formControlName="spouse_address" autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('spouse_address').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('spouse_address').hasError('pattern')">
                                    <strong>Invalid Format</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('spouse_address').hasError('maxlength')">
                                    <strong>Exceeds Max Limit</strong>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                            </div>
                            <!-- Father in law  -->
                            <div fxLayout="row" fxLayoutAlign="start center" class="family-wrapper">
                              <div fxLayout="row" fxLayoutAlign="start center" class="family-parent">
                                <mat-form-field class="family-formfield formField-height family-field">
                                  <mat-label>Father-in-Law Name</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput
                                    formControlName="fatherinlaw_name" autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('fatherinlaw_name').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('fatherinlaw_name').hasError('pattern')">
                                    <strong>Invalid Format</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('fatherinlaw_name').hasError('maxlength')">
                                    <strong>Exceeds Max Limit</strong>
                                  </mat-error>
                                </mat-form-field>
                                <mat-form-field class="dob formField-height family-field">
                                  <mat-label>DOB</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput
                                    formControlName="fatherinlaw_dob" [matDatepicker]="fatherInLawDOB"
                                    readonly="readonly" autocomplete="off" [max]="maxDate">
                                  <mat-datepicker-toggle matSuffix [for]="fatherInLawDOB"></mat-datepicker-toggle>
                                  <mat-datepicker #fatherInLawDOB></mat-datepicker>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('fatherinlaw_dob').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div fxLayout="row" fxLayoutAlign="start center" class="family-parent">
                                <mat-form-field class="family-formfield formField-height family-field">
                                  <mat-label>Gender</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput
                                    formControlName="fatherinlaw_gender" [readonly]="true" autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('fatherinlaw_gender').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                </mat-form-field>
                                <mat-form-field class="family-formfield formField-height family-field">
                                  <mat-label>Address</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput
                                    formControlName="fatherinlaw_address" autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('fatherinlaw_address').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('fatherinlaw_address').hasError('pattern')">
                                    <strong>Invalid Format</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('fatherinlaw_address').hasError('maxlength')">
                                    <strong>Exceeds Max Limit</strong>
                                  </mat-error>
                                </mat-form-field>
                              </div>

                            </div>
                            <!-- mother in law  -->
                            <div fxLayout="row" fxLayoutAlign="start center" class="family-wrapper">
                              <div fxLayout="row" fxLayoutAlign="start center" class="family-parent">
                                <mat-form-field class="family-formfield family-formfield formField-height">
                                  <mat-label>Mother-in-Law Name</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput
                                    formControlName="motherinlaw_name" autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('motherinlaw_name').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('motherinlaw_name').hasError('pattern')">
                                    <strong>Invalid Format</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('motherinlaw_name').hasError('maxlength')">
                                    <strong>Exceeds Max Limit</strong>
                                  </mat-error>
                                </mat-form-field>
                                <mat-form-field class="dob formField-height family-formfield">
                                  <mat-label>DOB</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput
                                    formControlName="motherinlaw_dob" [matDatepicker]="motherInLawDOB"
                                    readonly="readonly" autocomplete="off" [max]="maxDate">
                                  <mat-datepicker-toggle matSuffix [for]="motherInLawDOB"></mat-datepicker-toggle>
                                  <mat-datepicker #motherInLawDOB></mat-datepicker>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('motherinlaw_dob').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div fxLayout="row" fxLayoutAlign="start center" class="family-parent">
                                <mat-form-field class="family-formfield family-formfield formField-height">
                                  <mat-label>Gender</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput
                                    formControlName="motherinlaw_gender" [readonly]="true" autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('motherinlaw_gender').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                </mat-form-field>
                                <mat-form-field class="family-formfield family-formfield formField-height">
                                  <mat-label>Address</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput
                                    formControlName="motherinlaw_address" autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('motherinlaw_address').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('motherinlaw_address').hasError('pattern')">
                                    <strong>Invalid Format</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.get('motherinlaw_address').hasError('maxlength')">
                                    <strong>Exceeds Max Limit</strong>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                            </div>
                          </div>
                          <!-- Siblings  -->
                          <div class="subtitle-wrapper no-content-added" fxLayout="row"
                            fxLayoutAlign="space-between center">
                            <div class="onboard-subtitle">Siblings</div>
                            <button class="add-btn" type="button" mat-stroked-button placeholder="Add"
                              [disabled]="!editable || siblings.length == 5"
                              [class.delete-button-mobile]="siblings.length < 5 && editable == true"
                              (click)="additemToSibling()" style="margin: 1%;">
                              <mat-icon>add</mat-icon>
                              <span class="icon-content">Add</span>
                            </button>
                          </div>
                          <div class="no-content-container"
                            [class.no-content]="onboardCreateForm['controls'].family['controls'].siblings['controls'].length !== 0">
                            <div>
                              Siblings - Details Not Provided.
                            </div>
                          </div>
                          <!-- Sibling rows  -->
                          <div formArrayName="siblings"
                            *ngFor=" let data of onboardCreateForm['controls'].family['controls'].siblings['controls']; let i = index">
                            <div [formGroupName]="i" fxLayout="row" fxLayoutAlign="start center"
                              class="references-wrapper">
                              <div fxLayout="row" fxLayoutAlign="space-between center"
                                class="reference-name-wrapper sibiling-single-field">
                                <div class="candidate-details-number">
                                  {{i+1}}
                                </div>
                                <mat-form-field class="family-formfield reference-name-field formField-height">
                                  <mat-label>Name</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="name"
                                    autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.controls.siblings.controls[i].get('name').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.controls.siblings.controls[i].get('name').hasError('pattern')">
                                    <strong>Invalid Format</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.controls.siblings.controls[i].get('name').hasError('maxlength')">
                                    <strong>Exceeds Max Limit</strong>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div class="family-parent sibiling-two-field" fxLayout="row" fxLayoutAlign="start center">
                                <mat-form-field class="dob formField-height family-field">
                                  <mat-label>DOB</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="dob"
                                    [matDatepicker]="siblingsDOB" readonly="readonly" autocomplete="off"
                                    [max]="maxDate">
                                  <mat-datepicker-toggle matSuffix [for]="siblingsDOB"></mat-datepicker-toggle>
                                  <mat-datepicker #siblingsDOB></mat-datepicker>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.controls.siblings.controls[i].get('dob').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                </mat-form-field>
                                <mat-form-field class="family-formfield formField-height family-field">
                                  <mat-label>Gender</mat-label>
                                  <mat-select formControlName="gender" name="gender">
                                    <mat-option *ngFor="let gender of gender" [value]="gender.value">
                                      {{ gender.viewValue }}
                                    </mat-option>
                                  </mat-select>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.controls.siblings.controls[i].get('gender').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div fxLayout="row" class="reference-field sibiling-single-field"
                                fxLayoutAlign="space-between center">
                                <mat-form-field class="family-formfield formField-height reference-email">
                                  <mat-label>Address</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="address"
                                    autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.controls.siblings.controls[i].get('address').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.controls.siblings.controls[i].get('address').hasError('pattern')">
                                    <strong>Invalid Format</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.controls.siblings.controls[i].get('address').hasError('maxlength')">
                                    <strong>Exceeds Max Limit</strong>
                                  </mat-error>
                                </mat-form-field>
                                <button mat-button [disabled]="!editable" class="toolbar-icon-button"
                                  [class.delete-icon-button]="onboardCreateForm.disabled == false"
                                  [class.delete-icon-button-disabled]="onboardCreateForm.disabled == true"
                                  placeholder="Remove" (click)="deleteSibling(i)" matTooltip="Delete">
                                  <mat-icon class="material-icons highlight-off-closeicon"
                                    style="margin-right: 2.5px !important;">
                                    highlight_off
                                  </mat-icon>
                                </button>
                              </div>
                            </div>
                          </div>
                          <!-- Children  -->
                          <div class="subtitle-wrapper no-content-added" fxLayout="row"
                            fxLayoutAlign="space-between center">
                            <div class="onboard-subtitle">Children</div>
                            <button class="add-btn" type="button" mat-stroked-button placeholder="Add"
                              [disabled]="!editable  || children.length == 5"
                              [class.delete-button-mobile]="children.length < 5 && editable == true"
                              (click)="additemToChildren()" style="margin: 1%;">
                              <mat-icon>add</mat-icon>
                              <span class="icon-content">Add</span>
                            </button>
                          </div>
                          <div class="no-content-container"
                            [class.no-content]="onboardCreateForm['controls'].family['controls'].children['controls'].length !== 0">
                            <div>
                              Children - Details Not Provided.
                            </div>
                          </div>
                          <div formArrayName="children"
                            *ngFor="let data of onboardCreateForm['controls'].family['controls'].children['controls']; let i = index">
                            <div [formGroupName]="i" fxLayout="row" fxLayoutAlign="space-around center"
                              class="references-wrapper">
                              <div fxLayout="row" fxLayoutAlign="space-between center"
                                class="reference-name-wrapper sibiling-single-field">
                                <div class="candidate-details-number">
                                  {{i+1}}
                                </div>
                                <mat-form-field class="family-formfield formField-height reference-name-field">
                                  <mat-label>Name</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="name"
                                    autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.controls.children.controls[i].get('name').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.controls.children.controls[i].get('name').hasError('pattern')">
                                    <strong>Invalid Format</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.controls.children.controls[i].get('name').hasError('maxlength')">
                                    <strong>Exceeds Max Limit</strong>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div class="family-parent sibiling-two-field" fxLayout="row" fxLayoutAlign="start center">
                                <mat-form-field class="dob formField-height family-field">
                                  <mat-label>DOB</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="dob"
                                    [matDatepicker]="childrenDOB" readonly="readonly" autocomplete="off"
                                    [max]="maxDate">
                                  <mat-datepicker-toggle matSuffix [for]="childrenDOB"></mat-datepicker-toggle>
                                  <mat-datepicker #childrenDOB></mat-datepicker>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.controls.children.controls[i].get('dob').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                </mat-form-field>
                                <mat-form-field class="family-formfield formField-height family-field">
                                  <mat-label>Gender</mat-label>
                                  <mat-select formControlName="gender" name="gender">
                                    <mat-option *ngFor="let gender of gender" [value]="gender.value">
                                      {{ gender.viewValue }}
                                    </mat-option>
                                  </mat-select>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.controls.children.controls[i].get('gender').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                </mat-form-field>
                              </div>
                              <div fxLayout="row" class="reference-field sibiling-single-field"
                                fxLayoutAlign="space-between center">
                                <mat-form-field class="family-formfield formField-height reference-email">
                                  <mat-label>Address</mat-label>
                                  <input (keydown)="inputSpaceRestrict($event)" matInput formControlName="address"
                                    autocomplete="off">
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.controls.children.controls[i].get('address').hasError('required')">
                                    <strong>Required</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.controls.children.controls[i].get('address').hasError('pattern')">
                                    <strong>Invalid Format</strong>
                                  </mat-error>
                                  <mat-error
                                    *ngIf="onboardCreateForm.controls.family.controls.children.controls[i].get('address').hasError('maxlength')">
                                    <strong>Exceeds Max Limit</strong>
                                  </mat-error>
                                </mat-form-field>
                                <button mat-button matTooltip="Delete" [disabled]="!editable"
                                  class="toolbar-icon-button"
                                  [class.delete-icon-button]="onboardCreateForm.disabled == false"
                                  [class.delete-icon-button-disabled]="onboardCreateForm.disabled == true"
                                  placeholder="Remove" (click)="deleteChildren(i)" matTooltip="Delete">
                                  <mat-icon class="material-icons highlight-off-closeicon"
                                    style="margin-right: 2.5px !important;">
                                    highlight_off
                                  </mat-icon>
                                </button>
                              </div>
                            </div>
                          </div>
                          <!-- in-laws  -->
                          <!-- *ngIf="orgBasedOnboardFormsJson.inlawsFieldIsActive" -->
                        </div>
                        <!-- Emergency Contact : -->
                      </div>
                      <mat-card class="section-card" style="margin: 0px 1%;">
                        <div class="subtitle-wrapper no-content-added" fxLayout="row"
                          fxLayoutAlign="space-between center">
                          <div class="onboard-subtitle">Languages</div>
                          <button class="add-btn" type="button" mat-stroked-button placeholder="Add"
                            [disabled]="!editable  || language.length == 5"
                            [class.delete-button-mobile]="language.length < 5 && editable == true"
                            (click)="additemToLanguage()" style="margin: 1%;">
                            <mat-icon>add</mat-icon>
                            <span class="icon-content">Add</span>
                          </button>
                        </div>
                        <div class="no-content-container"
                          [class.no-content]="onboardCreateForm['controls'].language['controls'].length !== 0">
                          <div>
                            Languages - Details Not Provided.
                          </div>
                        </div>
                        <div formArrayName="language" class="references-wrapper"
                          *ngFor="let data of onboardCreateForm['controls'].language['controls'];let i = index">
                          <div fxLayout="row" fxLayoutAlign="start start" [formGroupName]="i"
                            style="margin-bottom: 12px;" class="family-wrapper language-field-wrapper">
                            <div fxLayout="row" fxLayoutAlign="space-between center"
                              class="reference-name-wrapper sibiling-single-field">
                              <div class="candidate-details-number">
                                {{i+1}}
                              </div>
                              <mat-form-field class="formField-height family-formfield reference-name-field">
                                <input (keydown)="inputSpaceRestrict($event)" matInput placeholder="Languages"
                                  [readonly]="!editable" formControlName="language" autocomplete="off">
                                <mat-error
                                  *ngIf="onboardCreateForm.controls.language.controls[i].get('language').hasError('required')">
                                  <strong>Required</strong>
                                </mat-error>
                                <mat-error
                                  *ngIf="onboardCreateForm.controls.language.controls[i].get('language').hasError('pattern')">
                                  <strong>Invalid Format</strong>
                                </mat-error>
                                <mat-error
                                  *ngIf="onboardCreateForm.controls.language.controls[i].get('language').hasError('maxlength')">
                                  <strong>Exceeds Max Limit</strong>
                                </mat-error>
                              </mat-form-field>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                              <mat-checkbox color="primary" [disabled]="!editable" formControlName="read">Read
                              </mat-checkbox>
                              <mat-checkbox color="primary" [disabled]="!editable" formControlName="write">Write
                              </mat-checkbox>
                              <mat-checkbox color="primary" [disabled]="!editable" formControlName="speak">Speak
                              </mat-checkbox>
                              <button mat-button [disabled]="!editable"
                                [class.delete-icon-button]="onboardCreateForm.disabled == false"
                                [class.delete-icon-button-disabled]="onboardCreateForm.disabled == true"
                                class="toolbar-icon-button" placeholder="Remove" (click)="deleteLanguage(i)"
                                matTooltip="Delete">
                                <mat-icon class="material-icons highlight-off-closeicon"
                                  style="margin-right: 2.5px !important;">
                                  highlight_off
                                </mat-icon>
                              </button>
                            </div>
                          </div>
                        </div>
                      </mat-card>
                      <mat-card class="section-card" style="margin: 0px 1%;">
                        <div class="subtitle-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
                          <div class="onboard-subtitle">Others</div>
                        </div>
                        <div fxLayout="row">
                          <div class="family-parent" fxLayout="row" fxLayoutAlign="start center">
                            <!-- *ngIf="orgBasedOnboardFormsJson.bloodgroupFieldIsActive" -->
                            <mat-form-field class="family-formfield formField-height family-field">
                              <!-- {{orgBasedOnboardFormsJson.bloodgroupFieldDisplayName}} -->
                              <mat-label>Blood Group</mat-label>
                              <!-- [required]="orgBasedOnboardFormsJson.bloodgroupFieldIsRequired" -->
                              <mat-select formControlName="bloodgroup" name="bloodgroup">
                                <mat-option *ngFor="let data of bloodgroup" [value]="data">
                                  {{ data }}
                                </mat-option>
                              </mat-select>
                              <mat-error *ngIf="onboardCreateForm.controls.bloodgroup.hasError('required')">
                                <strong>Required</strong>
                              </mat-error>
                              <mat-error *ngIf="onboardCreateForm.controls.bloodgroup.hasError('pattern')">
                                <strong>Invalid Format</strong>
                              </mat-error>
                              <mat-error *ngIf="onboardCreateForm.controls.bloodgroup.hasError('maxlength')">
                                <strong>Exceeds Max Limit</strong>
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <!-- Row 4  -->
                        <!-- *ngIf="orgBasedOnboardFormsJson.hobbiesFieldIsActive" -->
                        <div class="hobbies-container" fxFlex="50%">
                          <mat-form-field style="width: 96%;">
                            <!-- {{orgBasedOnboardFormsJson.hobbiesFieldDisplayName}} -->
                            <mat-label>Hobbies</mat-label>
                            <mat-chip-grid #chipHobbiesList formControlName="hobbies">
                              <mat-chip-row *ngFor="let hobbies of onboardCreateForm.get('hobbies').value"
                                [selectable]="selectable" (removed)="removeHobbies(hobbies,'Hobbies')">
                                {{hobbies}}
                                <mat-icon matChipRemove>close</mat-icon>
                              </mat-chip-row>
                              <input (keydown)="inputSpaceRestrict($event)" matInput [matChipInputFor]="chipHobbiesList"
                                maxlength="20" [readonly]="!editable"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                                autocomplete="off" (matChipInputTokenEnd)="addHobbies($event, 'Hobbies')">
                              <input type="hidden">
                            </mat-chip-grid>
                            <mat-hint align="end">{{onboardCreateForm.get('hobbies').value === null ? 7 : chipLength -
                              onboardCreateForm.get('hobbies').value.length }}</mat-hint>
                            <mat-error *ngIf="onboardCreateForm.controls.hobbies.hasError('required')">
                              <strong>Required</strong>
                            </mat-error>
                            <mat-error *ngIf="onboardCreateForm.controls.hobbies.hasError('pattern')">
                              <strong>Invalid Format</strong>
                            </mat-error>
                            <mat-error *ngIf="onboardCreateForm.controls.hobbies.hasError('maxlength')">
                              <strong>Exceeds Max Limit</strong>
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </mat-card>
                    </div>
                  </mat-card>
                </div>
              </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="end center" class="submit-button-wrapper">
              <a *ngIf="showErrorFields && errorFields.length > 0 " class="resolved-message" (click)="issuesResolved()">
                {{errorFields.length}} Issues to be resolved
                <mat-icon class="open-view-icon">
                  open_in_new
                </mat-icon>
              </a>
            </div>
            <mat-card class="section-card" *ngIf="formIndex === 2">
              <div class="subtitle-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
                <p class="section-title personal-title">
                  Compensation
                </p>
                <div fxLayout="row" fxLayoutAlign="end center" class="enter-button-wrapper">
                  <button *ngIf="compensationdoceditable"
                    (click)="cancelFileEdit('compensationdetails'); compensationdoceditable=false" mat-raised-button
                    class="edit-button cancel-button">
                    <mat-icon>close</mat-icon>
                    <span class="icon-content">Cancel</span>
                  </button>
                  <button *ngIf="!compensationdoceditable"
                    (click)="compensationdoceditable = true; enableFileEdit('compensationdetails')" mat-raised-button
                    class="edit-button">
                    <mat-icon>edit</mat-icon>
                    <span class="icon-content">Edit</span>
                  </button>
                  <button *ngIf="compensationdoceditable" mat-raised-button class="edit-button"
                    [disabled]="!onboardCreateForm.get('compensationdetails').dirty"
                    (click)="submitCompensationAccordion()">
                    <mat-icon>save</mat-icon>
                    <span class="icon-content">Update</span>
                  </button>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="space-around start" class="compensation-attachment-wrpper">
                <div fxLayout="column" fxLayoutGap="25px">
                  <!-- Salary Breakup -->
                  <div class="attachment-wrapper">
                    <div class="uploaded-file-name">
                      <div class="uploaded-name" [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                        fxLayoutAlign="start center" fxLayout="row">
                        <span
                          *ngIf="onboardCreateForm.get('compensationdetails').get('latestsalarybreakup').value != null && 
                              onboardCreateForm.get('compensationdetails').get('latestsalarybreakup').value != '' && 
                              onboardCreateForm.get('compensationdetails').get('latestsalarybreakup').value != 'delete' &&
                              onboardCreateForm.get('compensationdetails').get('latestsalarybreakup').value != undefined; else other_content">
                          <i class="fas fa-file-lines attach-icon"></i>
                        </span>
                        <ng-template #other_content>
                          <i class="fas fa-file-lines attach-icon-disable"></i>
                        </ng-template>
                        <div fxLayout="column">
                          <div class="doc-font-color">Salary Breakup</div>
                          <div class="supported-file">PDF or docx</div>
                        </div>
                      </div>
                    </div>
                    <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                      <a class="download-attachment disabled-a" [class.disabled-a]="!compensationdoceditable"
                        fxLayout="row" fxLayoutAlign="start center"
                        (click)="!compensationdoceditable ? 'javascript:void(0)': LatestSalBreakUp.click()">
                        <u>Upload</u>
                        &nbsp;
                        <span
                          *ngIf="onboardCreateForm.get('compensationdetails').get('latestsalarybreakup').value != null && 
                  onboardCreateForm.get('compensationdetails').get('latestsalarybreakup').value != '' && 
                  onboardCreateForm.get('compensationdetails').get('latestsalarybreakup').value != 'delete' &&
                  onboardCreateForm.get('compensationdetails').get('latestsalarybreakup').value != undefined; else salary_content">
                          <mat-icon class="completed-file-upload"> done</mat-icon>
                        </span>
                        &nbsp;
                        <input type="file" #LatestSalBreakUp
                          (change)="fileUpload($event,'compensationdetails','latestsalarybreakup'); LatestSalBreakUp.value=''"
                          accept=".pdf,.docx" required>
                      </a>
                      <span *ngIf="onboardCreateForm.get('compensationdetails').get('latestsalarybreakup').value != null && 
                        onboardCreateForm.get('compensationdetails').get('latestsalarybreakup').value != '' && 
                        onboardCreateForm.get('compensationdetails').get('latestsalarybreakup').value != 'delete' &&
                        onboardCreateForm.get('compensationdetails').get('latestsalarybreakup').value != undefined">
                        <a class="delete-attachment disabled-a" [class.disabled-a]="!compensationdoceditable" (click)="
                              !compensationdoceditable ? 'javascript:void(0)':
                              deleteDocumentFile('compensationdetails','latestsalarybreakup')">
                          <u>Delete</u>
                          &nbsp;</a>
                      </span>
                    </div>
                  </div>
                  <!-- Bonus/Variable Pay -->
                  <div class="attachment-wrapper">
                    <div class="uploaded-file-name">
                      <div class="uploaded-name" [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                        fxLayoutAlign="start center" fxLayout="row">
                        <span
                          *ngIf="onboardCreateForm.get('compensationdetails').get('bonuspayoutform').value != null && 
                            onboardCreateForm.get('compensationdetails').get('bonuspayoutform').value != '' && 
                            onboardCreateForm.get('compensationdetails').get('bonuspayoutform').value != 'delete' &&
                            onboardCreateForm.get('compensationdetails').get('bonuspayoutform').value != undefined; else other_content1">
                          <i class="fas fa-file-lines attach-icon"></i>
                        </span>
                        <ng-template #other_content1>
                          <i class="fas fa-file-lines attach-icon-disable"></i>
                        </ng-template>
                        <div fxLayout="column">
                          <div class="doc-font-color">Bonus/Variable Pay</div>
                          <div class="supported-file">PDF or docx</div>
                        </div>
                      </div>

                    </div>
                    <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                      <a class="download-attachment disabled-a" [class.disabled-a]="!compensationdoceditable"
                        fxLayout="row" fxLayoutAlign="start center"
                        (click)="!compensationdoceditable ? 'javascript:void(0)': BonusVP.click()">
                        <u>Upload</u>
                        &nbsp;
                        <span
                          *ngIf="onboardCreateForm.get('compensationdetails').get('bonuspayoutform').value != null && 
                        onboardCreateForm.get('compensationdetails').get('bonuspayoutform').value != '' && 
                        onboardCreateForm.get('compensationdetails').get('bonuspayoutform').value != 'delete' &&
                        onboardCreateForm.get('compensationdetails').get('bonuspayoutform').value != undefined; else bonus_content">
                          <mat-icon class="completed-file-upload"> done</mat-icon>
                        </span>
                        &nbsp;
                        <input type="file" #BonusVP
                          (change)="fileUpload($event,'compensationdetails','bonuspayoutform');BonusVP.value=''"
                          accept=".pdf,.docx" required>
                      </a>
                      <span *ngIf="onboardCreateForm.get('compensationdetails').get('bonuspayoutform').value != null && 
                            onboardCreateForm.get('compensationdetails').get('bonuspayoutform').value != '' && 
                            onboardCreateForm.get('compensationdetails').get('bonuspayoutform').value != 'delete' &&
                            onboardCreateForm.get('compensationdetails').get('bonuspayoutform').value != undefined">

                        <a class="delete-attachment disabled-a" [class.disabled-a]="!compensationdoceditable" (click)="
                              !compensationdoceditable ? 'javascript:void(0)':
                              deleteDocumentFile('compensationdetails','bonuspayoutform')">
                          <u>Delete</u>
                          &nbsp;</a>
                      </span>
                    </div>
                  </div>
                  <!-- Bank Statement -->
                  <div class="attachment-wrapper">
                    <div class="uploaded-file-name">
                      <div class="uploaded-name" [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                        fxLayoutAlign="start center" fxLayout="row">
                        <span
                          *ngIf="onboardCreateForm.get('compensationdetails').get('bankstatement').value != null && 
                            onboardCreateForm.get('compensationdetails').get('bankstatement').value != '' && 
                            onboardCreateForm.get('compensationdetails').get('bankstatement').value != 'delete' &&
                            onboardCreateForm.get('compensationdetails').get('bankstatement').value != undefined; else other_content2">
                          <i class="fas fa-file-lines attach-icon"></i>
                        </span>
                        <ng-template #other_content2>
                          <i class="fas fa-file-lines attach-icon-disable"></i>
                        </ng-template>
                        <div fxLayout="column">
                          <div class="doc-font-color">Bank Statement</div>
                          <div class="supported-file">PDF or docx</div>
                        </div>
                      </div>

                    </div>
                    <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                      <a class="download-attachment disabled-a" [class.disabled-a]="!compensationdoceditable"
                        fxLayout="row" fxLayoutAlign="start center"
                        (click)="!compensationdoceditable ? 'javascript:void(0)': BankStatement.click()">
                        <u>Upload</u>
                        &nbsp;
                        <span
                          *ngIf="onboardCreateForm.get('compensationdetails').get('bankstatement').value != null && 
                            onboardCreateForm.get('compensationdetails').get('bankstatement').value != '' && 
                            onboardCreateForm.get('compensationdetails').get('bankstatement').value != 'delete' &&
                            onboardCreateForm.get('compensationdetails').get('bankstatement').value != undefined; else bank_content">
                          <mat-icon class="completed-file-upload"> done</mat-icon>
                        </span>
                        &nbsp;
                        <input type="file" #BankStatement
                          (change)="fileUpload($event,'compensationdetails','bankstatement');BankStatement.value=''"
                          accept=".pdf,.docx" required>
                      </a>
                      <span *ngIf="onboardCreateForm.get('compensationdetails').get('bankstatement').value != null && 
                              onboardCreateForm.get('compensationdetails').get('bankstatement').value != '' && 
                              onboardCreateForm.get('compensationdetails').get('bankstatement').value != 'delete' &&
                              onboardCreateForm.get('compensationdetails').get('bankstatement').value != undefined">
                        <a class="delete-attachment disabled-a" [class.disabled-a]="!compensationdoceditable" (click)="
                                !compensationdoceditable ? 'javascript:void(0)':
                                deleteDocumentFile('compensationdetails','bankstatement')">
                          <u>Delete</u>
                          &nbsp;</a>
                      </span>
                    </div>
                  </div>
                </div>
                <div fxLayout="column" fxLayoutGap="25px">
                  <!--Pay SLip 1-->
                  <div class="attachment-wrapper">
                    <div class="uploaded-file-name">
                      <div class="uploaded-name" [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                        fxLayoutAlign="start center" fxLayout="row">
                        <span
                          *ngIf="onboardCreateForm.get('compensationdetails').get('payslip1').value != null && 
                            onboardCreateForm.get('compensationdetails').get('payslip1').value != '' && 
                            onboardCreateForm.get('compensationdetails').get('payslip1').value != 'delete' &&
                            onboardCreateForm.get('compensationdetails').get('payslip1').value != undefined; else other_content3">
                          <i class="fas fa-file-lines attach-icon"></i>
                        </span>
                        <ng-template #other_content3>
                          <i class="fas fa-file-lines attach-icon-disable"></i>
                        </ng-template>
                        <div fxLayout="column">
                          <div class="doc-font-color">Payslip 1</div>
                          <div class="supported-file">PDF or docx</div>
                        </div>
                      </div>
                    </div>
                    <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                      <a class="download-attachment disabled-a" [class.disabled-a]="!compensationdoceditable"
                        fxLayout="row" fxLayoutAlign="start center"
                        (click)="!compensationdoceditable ? 'javascript:void(0)': payslip1.click()">
                        <u>Upload</u>
                        &nbsp;
                        <span
                          *ngIf="onboardCreateForm.get('compensationdetails').get('payslip1').value != null && 
                        onboardCreateForm.get('compensationdetails').get('payslip1').value != '' && 
                        onboardCreateForm.get('compensationdetails').get('payslip1').value != 'delete' &&
                        onboardCreateForm.get('compensationdetails').get('payslip1').value != undefined; else pay_slip">
                          <mat-icon class="completed-file-upload"> done</mat-icon>
                        </span>
                        &nbsp;
                        <input (change)="fileUpload($event,'compensationdetails','payslip1');payslip1.value=''"
                          accept=".pdf,.docx" required type="file" #payslip1>
                      </a>
                      <span *ngIf="onboardCreateForm.get('compensationdetails').get('payslip1').value != null && 
                            onboardCreateForm.get('compensationdetails').get('payslip1').value != '' && 
                            onboardCreateForm.get('compensationdetails').get('payslip1').value != 'delete' &&
                            onboardCreateForm.get('compensationdetails').get('payslip1').value != undefined">
                        <a class="delete-attachment disabled-a" [class.disabled-a]="!compensationdoceditable" (click)="
                              !compensationdoceditable ? 'javascript:void(0)':
                              deleteDocumentFile('compensationdetails','payslip1')">
                          <u>Delete</u>
                          &nbsp;</a>
                      </span>
                    </div>
                  </div>
                  <!-- PaySlip 2 Form  -->
                  <div class="attachment-wrapper">
                    <div class="uploaded-file-name">
                      <div class="uploaded-name" [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                        fxLayoutAlign="start center" fxLayout="row">
                        <span
                          *ngIf="onboardCreateForm.get('compensationdetails').get('payslip2').value != null && 
                            onboardCreateForm.get('compensationdetails').get('payslip2').value != '' && 
                            onboardCreateForm.get('compensationdetails').get('payslip2').value != 'delete' &&
                            onboardCreateForm.get('compensationdetails').get('payslip2').value != undefined; else other_content4">
                          <i class="fas fa-file-lines attach-icon"></i>
                        </span>
                        <ng-template #other_content4>
                          <i class="fas fa-file-lines attach-icon-disable"></i>
                        </ng-template>
                        <div fxLayout="column">
                          <div class="doc-font-color">Payslip 2</div>
                          <div class="supported-file">PDF or docx</div>
                        </div>
                      </div>
                    </div>
                    <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                      <a class="download-attachment disabled-a" [class.disabled-a]="!compensationdoceditable"
                        fxLayout="row" fxLayoutAlign="start center"
                        (click)="!compensationdoceditable ? 'javascript:void(0)': payslip2.click()">
                        <u>Upload</u>
                        &nbsp;
                        <span
                          *ngIf="onboardCreateForm.get('compensationdetails').get('payslip2').value != null && 
                        onboardCreateForm.get('compensationdetails').get('payslip2').value != '' && 
                        onboardCreateForm.get('compensationdetails').get('payslip2').value != 'delete' &&
                        onboardCreateForm.get('compensationdetails').get('payslip2').value != undefined; else pay_slip2">
                          <mat-icon class="completed-file-upload"> done</mat-icon>
                        </span>
                        &nbsp;
                        <input type="file" #payslip2
                          (change)="fileUpload($event,'compensationdetails','payslip2');payslip2.value=''"
                          accept=".pdf,.docx" required>
                      </a>
                      <span *ngIf="onboardCreateForm.get('compensationdetails').get('payslip2').value != null && 
                            onboardCreateForm.get('compensationdetails').get('payslip2').value != '' && 
                            onboardCreateForm.get('compensationdetails').get('payslip2').value != 'delete' &&
                            onboardCreateForm.get('compensationdetails').get('payslip2').value != undefined">

                        <a class="delete-attachment disabled-a" [class.disabled-a]="!compensationdoceditable" (click)="
                              !compensationdoceditable ? 'javascript:void(0)':
                              deleteDocumentFile('compensationdetails','payslip2')">
                          <u>Delete</u>
                          &nbsp;</a>
                      </span>
                    </div>
                  </div>
                  <!-- Payslip 3 -->
                  <div class="attachment-wrapper">
                    <div class="uploaded-file-name">
                      <div class="uploaded-name" [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                        fxLayoutAlign="start center" fxLayout="row">
                        <span
                          *ngIf="onboardCreateForm.get('compensationdetails').get('payslip3').value != null && 
                            onboardCreateForm.get('compensationdetails').get('payslip3').value != '' && 
                            onboardCreateForm.get('compensationdetails').get('payslip3').value != 'delete' &&
                            onboardCreateForm.get('compensationdetails').get('payslip3').value != undefined; else other_content5">
                          <i class="fas fa-file-lines attach-icon"></i>
                        </span>
                        <ng-template #other_content5>
                          <i class="fas fa-file-lines attach-icon-disable"></i>
                        </ng-template>
                        <div fxLayout="column">
                          <div class="doc-font-color">Payslip 3</div>
                          <div class="supported-file">PDF or docx</div>
                        </div>
                      </div>
                    </div>
                    <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                      <a class="download-attachment disabled-a" [class.disabled-a]="!compensationdoceditable"
                        fxLayout="row" fxLayoutAlign="start center"
                        (click)="!compensationdoceditable ? 'javascript:void(0)': payslip3.click()">
                        <u>Upload</u>
                        &nbsp;
                        <span
                          *ngIf="onboardCreateForm.get('compensationdetails').get('payslip3').value != null && 
                        onboardCreateForm.get('compensationdetails').get('payslip3').value != '' && 
                        onboardCreateForm.get('compensationdetails').get('payslip3').value != 'delete' &&
                        onboardCreateForm.get('compensationdetails').get('payslip3').value != undefined; else pay_slip3">
                          <mat-icon class="completed-file-upload"> done</mat-icon>
                        </span>
                        &nbsp;
                        <input type="file" #payslip3
                          (change)="fileUpload($event,'compensationdetails','payslip3');payslip3.value=''"
                          accept=".pdf,.docx" required>
                      </a>
                      <span *ngIf="onboardCreateForm.get('compensationdetails').get('payslip3').value != null && 
                          onboardCreateForm.get('compensationdetails').get('payslip3').value != '' && 
                          onboardCreateForm.get('compensationdetails').get('payslip3').value != 'delete' &&
                          onboardCreateForm.get('compensationdetails').get('payslip3').value != undefined">

                        <a class="delete-attachment disabled-a" [class.disabled-a]="!compensationdoceditable" (click)="
                            !compensationdoceditable ? 'javascript:void(0)':
                            deleteDocumentFile('compensationdetails','payslip3')">
                          <u>Delete</u>
                          &nbsp;</a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <br>
            </mat-card>
            <!-- Id Attachments Tab  -->
            <!-- *ngIf="orgBasedOnboardFormsJson.idattachmentFieldIsActive" -->
            <!-- [label]="orgBasedOnboardFormsJson.idattachmentFieldDisplayName" -->
            <mat-card class="section-card" *ngIf="formIndex === 3">
              <div class="subtitle-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
                <p class="section-title personal-title">
                  ID Attachments
                </p>
                <div fxLayout="row" fxLayoutAlign="end center" class="enter-button-wrapper">
                  <button *ngIf="iddoceditable" (click)="cancelFileEdit('idattachments'); iddoceditable=false"
                    mat-raised-button class="edit-button cancel-button">
                    <mat-icon>close</mat-icon>
                    <span class="icon-content">Cancel</span>
                  </button>

                  <button *ngIf="!iddoceditable" (click)="iddoceditable = true; enableFileEdit('idattachments')"
                    mat-raised-button class="edit-button">
                    <!-- *ngIf="!iddoceditable && ((loggedInUserrole.includes('Recruitmentmanager') && rowInfo.assignedto.toLowerCase() === loggedInUsername.toLowerCase())|| !loggedInUserrole.includes('Recruitmentmanager'))"-->
                    <mat-icon>edit</mat-icon>
                    <span class="icon-content">Edit</span>
                  </button>
                  <button *ngIf="iddoceditable" mat-raised-button class="edit-button"
                    [disabled]="!onboardCreateForm.get('idattachments').dirty" (click)="submitIDAccordion()">
                    <mat-icon>save</mat-icon>
                    <span class="icon-content">Update</span>
                  </button>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="space-around start" class="compensation-attachment-wrpper">
                <div fxLayout="column" fxLayoutGap="25px">
                  <!-- Pan card Form  -->
                  <div class="attachment-wrapper">
                    <div class="uploaded-file-name">
                      <div class="uploaded-name" [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                        fxLayoutAlign="start center" fxLayout="row">
                        <span
                          *ngIf="onboardCreateForm.get('idattachments').get('pancard').value != null && 
                            onboardCreateForm.get('idattachments').get('pancard').value != '' && 
                            onboardCreateForm.get('idattachments').get('pancard').value != 'delete' &&
                            onboardCreateForm.get('idattachments').get('pancard').value != undefined; else id_other_content">
                          <i class="fas fa-file-lines attach-icon"></i>
                        </span>
                        <ng-template #id_other_content>
                          <i class="fas fa-file-lines attach-icon-disable"></i>
                        </ng-template>
                        <div fxLayout="column">
                          <div class="doc-font-color">Tax ID</div>
                          <div class="supported-file">PDF or docx</div>
                        </div>
                      </div>
                    </div>
                    <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                      <a class="download-attachment disabled-a" [class.disabled-a]="!iddoceditable" fxLayout="row"
                        fxLayoutAlign="start center" (click)="!iddoceditable ? 'javascript:void(0)': pancard.click()">
                        <u>Upload</u>
                        &nbsp;
                        <span *ngIf="onboardCreateForm.get('idattachments').get('pancard').value != null && 
                        onboardCreateForm.get('idattachments').get('pancard').value != '' && 
                        onboardCreateForm.get('idattachments').get('pancard').value != 'delete' &&
                        onboardCreateForm.get('idattachments').get('pancard').value != undefined;">
                          <mat-icon class="completed-file-upload"> done</mat-icon>
                        </span>
                        &nbsp;
                        <input type="file" #pancard
                          (change)="fileUpload($event,'idattachments','pancard');pancard.value=''" accept=".pdf,.docx"
                          required>
                      </a>
                      <!-- Other Files related functions  -->
                      <span *ngIf="onboardCreateForm.get('idattachments').get('pancard').value != null && 
                          onboardCreateForm.get('idattachments').get('pancard').value != '' && 
                          onboardCreateForm.get('idattachments').get('pancard').value != 'delete' &&
                          onboardCreateForm.get('idattachments').get('pancard').value != undefined">
                        <a class="delete-attachment disabled-a" [class.disabled-a]="!iddoceditable" (click)="
                            !iddoceditable ? 'javascript:void(0)':
                            deleteDocumentFile('idattachments','pancard')">
                          <u>Delete</u>
                          &nbsp;</a>
                      </span>
                    </div>
                  </div>
                  <!-- Aadhar Form  -->
                  <div class="attachment-wrapper">
                    <div class="uploaded-file-name">
                      <div class="uploaded-name" [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                        fxLayoutAlign="start center" fxLayout="row">
                        <span
                          *ngIf="onboardCreateForm.get('idattachments').get('ssn').value != null && 
                            onboardCreateForm.get('idattachments').get('ssn').value != '' && 
                            onboardCreateForm.get('idattachments').get('ssn').value != 'delete' &&
                            onboardCreateForm.get('idattachments').get('ssn').value != undefined; else id_other_content1">
                          <i class="fas fa-file-lines attach-icon"></i>
                        </span>
                        <ng-template #id_other_content1>
                          <i class="fas fa-file-lines attach-icon-disable"></i>
                        </ng-template>
                        <!-- {{orgBasedOnboardFormsJson.ssnatchmntFieldDisplayName}} -->
                        <div fxLayout="column">
                          <div class="doc-font-color">Social Security ID</div>
                          <div class="supported-file">PDF or docx</div>
                        </div>
                      </div>
                    </div>
                    <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                      <a class="download-attachment disabled-a" [class.disabled-a]="!iddoceditable" fxLayout="row"
                        fxLayoutAlign="start center" (click)="!iddoceditable ? 'javascript:void(0)': ssn.click()">
                        <u>Upload</u>
                        &nbsp;
                        <span *ngIf="onboardCreateForm.get('idattachments').get('ssn').value != null && 
                        onboardCreateForm.get('idattachments').get('ssn').value != '' && 
                        onboardCreateForm.get('idattachments').get('ssn').value != 'delete' &&
                        onboardCreateForm.get('idattachments').get('ssn').value != undefined;">
                          <mat-icon class="completed-file-upload"> done</mat-icon>
                        </span>
                        &nbsp;
                        <input type="file" #ssn (change)="fileUpload($event,'idattachments','ssn');ssn.value=''"
                          accept=".pdf,.docx" required>
                      </a>
                      <!-- Other Files related functions  -->
                      <span *ngIf="onboardCreateForm.get('idattachments').get('ssn').value != null && 
                            onboardCreateForm.get('idattachments').get('ssn').value != '' && 
                            onboardCreateForm.get('idattachments').get('ssn').value != 'delete' &&
                            onboardCreateForm.get('idattachments').get('ssn').value != undefined">
                        <a class="delete-attachment disabled-a" [class.disabled-a]="!iddoceditable" (click)="
                              !iddoceditable ? 'javascript:void(0)':
                              deleteDocumentFile('idattachments','ssn')">
                          <u>Delete</u>
                          &nbsp;</a>
                      </span>
                    </div>
                  </div>
                </div>
                <div fxLayout="column" fxLayoutGap="25px">
                  <!-- Passport Form  -->
                  <div class="attachment-wrapper">
                    <div class="uploaded-file-name">
                      <div class="uploaded-name" [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                        fxLayoutAlign="start center" fxLayout="row">
                        <span
                          *ngIf="onboardCreateForm.get('idattachments').get('passport').value != null && 
                            onboardCreateForm.get('idattachments').get('passport').value != '' && 
                            onboardCreateForm.get('idattachments').get('passport').value != 'delete' &&
                            onboardCreateForm.get('idattachments').get('passport').value != undefined; else id_other_content2">
                          <i class="fas fa-file-lines attach-icon"></i>
                        </span>
                        <ng-template #id_other_content2>
                          <i class="fas fa-file-lines attach-icon-disable"></i>
                        </ng-template>
                        <!-- {{orgBasedOnboardFormsJson.passportatchmntFieldDisplayName}} -->
                        <div fxLayout="column">
                          <div class="doc-font-color">Passport Scan</div>
                          <div class="supported-file">PDF or docx</div>
                        </div>
                      </div>
                    </div>
                    <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                      <a class="download-attachment disabled-a" [class.disabled-a]="!iddoceditable" fxLayout="row"
                        fxLayoutAlign="start center" (click)="!iddoceditable ? 'javascript:void(0)': passport.click()">
                        <u>Upload</u>
                        &nbsp;
                        <span *ngIf="onboardCreateForm.get('idattachments').get('passport').value != null && 
                        onboardCreateForm.get('idattachments').get('passport').value != '' && 
                        onboardCreateForm.get('idattachments').get('passport').value != 'delete' &&
                        onboardCreateForm.get('idattachments').get('passport').value != undefined;">
                          <mat-icon class="completed-file-upload"> done</mat-icon>
                        </span>
                        &nbsp;
                        <input type="file" #passport
                          (change)="fileUpload($event,'idattachments','passport');passport.value=''" accept=".pdf,.docx"
                          required>
                      </a>
                      <!-- Other Files related functions  -->
                      <span *ngIf="onboardCreateForm.get('idattachments').get('passport').value != null && 
                          onboardCreateForm.get('idattachments').get('passport').value != '' && 
                          onboardCreateForm.get('idattachments').get('passport').value != 'delete' &&
                          onboardCreateForm.get('idattachments').get('passport').value != undefined">
                        <a class="delete-attachment disabled-a" [class.disabled-a]="!iddoceditable" (click)="
                            !iddoceditable ? 'javascript:void(0)':
                            deleteDocumentFile('idattachments','passport')">
                          <u>Delete</u>
                          &nbsp;</a>
                      </span>
                    </div>
                  </div>
                  <!-- Photo  -->
                  <div class="attachment-wrapper">
                    <div class="uploaded-file-name">
                      <div class="uploaded-name" [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                        fxLayoutAlign="start center" fxLayout="row">
                        <span
                          *ngIf="onboardCreateForm.get('idattachments').get('photograph').value != null && 
                            onboardCreateForm.get('idattachments').get('photograph').value != '' && 
                            onboardCreateForm.get('idattachments').get('photograph').value != 'delete' &&
                            onboardCreateForm.get('idattachments').get('photograph').value != undefined; else id_other_content3">
                          <i class="fas fa-file-image attach-icon-disable attach-icon"></i>
                        </span>
                        <ng-template #id_other_content3>
                          <i class="fas fa-file-image attach-icon-disable"></i>
                        </ng-template>
                        <!-- {{orgBasedOnboardFormsJson.photoatchmntFieldDisplayName}} -->
                        <div fxLayout="column">
                          <div class="doc-font-color">Additional Document</div>
                          <div class="supported-file">Png or Jpeg.</div>
                        </div>
                      </div>
                    </div>
                    <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                      <a class="download-attachment disabled-a" [class.disabled-a]="!iddoceditable" fxLayout="row"
                        fxLayoutAlign="start center"
                        (click)="!iddoceditable ? 'javascript:void(0)': photograph.click()">
                        <u>Upload</u>
                        &nbsp;
                        <span *ngIf="onboardCreateForm.get('idattachments').get('photograph').value != null && 
                        onboardCreateForm.get('idattachments').get('photograph').value != '' && 
                        onboardCreateForm.get('idattachments').get('photograph').value != 'delete' &&
                        onboardCreateForm.get('idattachments').get('photograph').value != undefined;">
                          <mat-icon class="completed-file-upload"> done</mat-icon>
                        </span>
                        &nbsp;
                        <input type="file" #photograph
                          (change)="fileUploadPhoto($event,'idattachments','photograph');photograph.value=''"
                          accept=".png,.jpg,.jpeg" required>
                      </a>
                      <!-- Other Files related functions  -->
                      <span *ngIf="onboardCreateForm.get('idattachments').get('photograph').value != null && 
                          onboardCreateForm.get('idattachments').get('photograph').value != '' && 
                          onboardCreateForm.get('idattachments').get('photograph').value != 'delete' &&
                          onboardCreateForm.get('idattachments').get('photograph').value != undefined">
                        <a class="delete-attachment disabled-a" [class.disabled-a]="!iddoceditable" (click)="
                            !iddoceditable ? 'javascript:void(0)':
                            deleteDocumentFile('idattachments','photograph')">
                          <u>Delete</u>
                          &nbsp;</a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <br>
            </mat-card>
            <!-- Edu Exp Tab  -->
            <!-- *ngIf="orgBasedOnboardFormsJson.eduexpatchmntFieldIsActive" -->
            <!-- [label]="orgBasedOnboardFormsJson.eduexpatchmntFieldDisplayName" -->
            <div *ngIf="formIndex === 4" [formGroup]="onboardCreateForm">
              <div class="subtitle-wrapper additional-title-wrapper" fxLayout="row"
                fxLayoutAlign="space-between center">
                <p class="section-title personal-title">
                  Education Proofs
                </p>
                <div fxLayout="row" fxLayoutAlign="end center" class="enter-button-wrapper">
                  <button class="add-btn" type="button" mat-stroked-button placeholder="Add"
                    matTooltip="Add New Attachment" [disabled]="!eduexpdoceditable || educationproof.length == 5"
                    [class.delete-button-mobile]="eduexpdoceditable == true && educationproof.length < 5"
                    (click)="additemToAttachmentEducation()" style="margin: 1%;">
                    <mat-icon>add</mat-icon>
                    <span class="icon-content">Add</span>
                  </button>
                  <button *ngIf="eduexpdoceditable"
                    (click)="cancelFileEdit('eduexpattachments'); eduexpdoceditable=false" mat-raised-button
                    class="edit-button cancel-button">
                    <mat-icon>close</mat-icon>
                    <span class="icon-content">Cancel</span>
                  </button>
                  <button *ngIf="!eduexpdoceditable"
                    (click)="eduexpdoceditable = true; enableFileEdit('eduexpattachments')" mat-raised-button
                    class="edit-button">
                    <!-- *ngIf="!eduexpdoceditable && ((loggedInUserrole.includes('Recruitmentmanager') && rowInfo.assignedto.toLowerCase() === loggedInUsername.toLowerCase())|| !loggedInUserrole.includes('Recruitmentmanager'))"-->
                    <mat-icon>edit</mat-icon>
                    <span class="icon-content">Edit</span>
                  </button>
                  <button *ngIf="eduexpdoceditable" mat-raised-button class="edit-button"
                    [disabled]="!onboardCreateForm.get('eduexpattachments').get('educationproof').dirty"
                    (click)="submitEduExpAccordion('education')">
                    <mat-icon>save</mat-icon>
                    <span class="icon-content">Update</span>
                  </button>
                </div>
              </div>
              <div class="additional-container">
                <div formGroupName="eduexpattachments" fxLayout="column">
                  <mat-card class="section-card">
                    <!-- <div class="subtitle-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
                      <div class="onboard-subtitle">Education Attachments</div>
                      <button type="button" mat-stroked-button placeholder="Add" matTooltip="Add New Attachment"
                        [disabled]="!eduexpdoceditable || educationproof.length == 5"
                        [class.delete-button-mobile]="eduexpdoceditable == true && educationproof.length < 5"
                        (click)="additemToAttachmentEducation()" style="margin: 1%;">+
                        Add</button>
                    </div> -->
                    <!-- Row 2  -->
                    <div class="edu-attachment-wrpper">
                      <div formArrayName="educationproof" fxLayout="row" fxLayoutAlign="center center"
                        *ngFor="let data of onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls']; let i = index">
                        <div class="education-wrapper" fxLayout="column">
                          <div class="attachment-wrapper" [formGroupName]="i"
                            *ngIf="onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').value != 'delete'">
                            <div class="uploaded-file-name education-attach">
                              <div class="uploaded-name"
                                [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                                fxLayoutAlign="start center" fxLayout="row">
                                <span
                                  *ngIf="onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').value != null && 
                              onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').value !== '' && 
                              onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').value !== 'delete' &&
                              onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').value !== undefined; else edu_other_content">
                                  <i class="fas fa-file-lines attach-icon"></i>
                                </span>
                                <ng-template #edu_other_content>
                                  <i class="fas fa-file-lines attach-icon-disable"></i>
                                </ng-template>
                                <div fxLayout="column">
                                  <div class="doc-font-color">
                                    <mat-form-field [ngClass]="!eduexpdoceditable ? 'disabled-field' : ''">
                                      <input matInput formControlName="filename" class="file-name"
                                        (input)="triggerUniqueNameValidator('education')" placeholder="File Name"
                                        autocomplete="off" [readonly]="!eduexpdoceditable" maxlength="50">
                                      <!-- Required error -->
                                      <mat-error
                                        *ngIf="onboardCreateForm.get('eduexpattachments').get('educationproof').at(i).get('filename').hasError('required')">
                                        <strong>Required</strong>
                                      </mat-error>

                                      <!-- Duplicate name error -->
                                      <mat-error
                                        *ngIf="onboardCreateForm.get('eduexpattachments').get('educationproof').at(i).get('filename').hasError('duplicateName')">
                                        <strong>Duplicate Name</strong>
                                      </mat-error>
                                    </mat-form-field>

                                  </div>
                                  <div class="supported-file input-file">PDF or docx</div>
                                </div>
                              </div>
                            </div>
                            <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                              <span fxLayout="row" fxLayoutAlign="start center">
                                <a class="download-attachment disabled-a" [class.disabled-a]="!eduexpdoceditable"
                                  fxLayout="row" fxLayoutAlign="start center"
                                  (click)="!eduexpdoceditable ? 'javascript:void(0)': fileEducation.click()">
                                  <u>Upload</u>
                                  &nbsp;
                                  <span
                                    *ngIf="onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').value != null && 
                              onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').value !== '' && 
                              onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').value !== 'delete' &&
                              onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').value !== undefined;">
                                    <mat-icon class="completed-file-upload"> done</mat-icon>
                                  </span>
                                  &nbsp;
                                  <input type="file" #fileEducation
                                    (change)="fileUploadEducation($event, i);fileEducation.value=''"
                                    accept=".pdf,.docx">
                                </a>
                                <mat-error class="required-error" matTooltip="Required"
                                  *ngIf="onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').hasError('required') && 
                            onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').touched">
                                  <mat-icon>error</mat-icon>
                                </mat-error>
                              </span>
                              <span>
                                <span
                                  *ngIf="onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').value != null && 
                              onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').value !== '' && 
                              onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').value !== 'delete' &&
                              onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').value !== undefined">
                                  <a class="delete-attachment disabled-a" [class.disabled-a]="!eduexpdoceditable"
                                    (click)="!eduexpdoceditable ? 'javascript:void(0)':deleteAttachmentEducation(i)">
                                    <u>Delete</u> &nbsp;</a>
                                </span>
                                <a class="delete-attachment disabled-a" style="text-align: end;"
                                  [class.disabled-a]="!eduexpdoceditable"
                                  *ngIf="onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').value == null ||
                            onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').value == '' ||
                            onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').value == 'delete' ||
                            onboardCreateForm['controls'].eduexpattachments['controls'].educationproof['controls'][i].get('filecontent').value == undefined"
                                  (click)="!eduexpdoceditable ? 'javascript:void(0)':deleteAttachmentEducation(i)">
                                  <u>Remove</u> &nbsp;</a>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div *ngIf="educationproof.length % 2 !== 0" fxFlex="250px" class="edu-exp-container">
                      </div> -->
                    </div>
                    <br>
                  </mat-card>
                </div>
              </div>
            </div>
            <!-- Experience Proofs -->
            <div *ngIf="formIndex === 5" [formGroup]="onboardCreateForm">
              <div class="subtitle-wrapper additional-title-wrapper" fxLayout="row"
                fxLayoutAlign="space-between center">
                <p class="section-title personal-title">
                  Experience Proofs
                </p>
                <div fxLayout="row" fxLayoutAlign="end center" class="enter-button-wrapper">
                  <button class="add-btn" type="button" mat-stroked-button placeholder="Add"
                    [disabled]="!eduexpdoceditable || experienceproof.length == 5"
                    [class.delete-button-mobile]="eduexpdoceditable == true && experienceproof.length < 5"
                    (click)="additemToAttachmentExperience()" matTooltip="Add New Attachment" style="margin: 1%;">
                    <mat-icon>add</mat-icon>
                    <span class="icon-content">Add</span>
                  </button>
                  <button *ngIf="eduexpdoceditable"
                    (click)="cancelFileEdit('eduexpattachments'); eduexpdoceditable=false" mat-raised-button
                    class="edit-button cancel-button">
                    <mat-icon>close</mat-icon>
                    <span class="icon-content">Cancel</span>
                  </button>

                  <button *ngIf="!eduexpdoceditable"
                    (click)="eduexpdoceditable = true; enableFileEdit('eduexpattachments')" mat-raised-button
                    class="edit-button">
                    <!-- *ngIf="!eduexpdoceditable && ((loggedInUserrole.includes('Recruitmentmanager') && rowInfo.assignedto.toLowerCase() === loggedInUsername.toLowerCase())|| !loggedInUserrole.includes('Recruitmentmanager'))"-->
                    <mat-icon>edit</mat-icon>
                    <span class="icon-content">Edit</span>
                  </button>
                  <button *ngIf="eduexpdoceditable" mat-raised-button class="edit-button"
                    [disabled]="!onboardCreateForm.get('eduexpattachments').get('experienceproof').dirty"
                    (click)="submitEduExpAccordion('experience')">
                    <mat-icon>save</mat-icon>
                    <span class="icon-content">Update</span>
                  </button>
                </div>
              </div>
              <div class="additional-container">
                <div formGroupName="eduexpattachments" fxLayout="column">
                  <mat-card class="section-card">
                    <!-- <div class="subtitle-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
                      <div class="onboard-subtitle">Experience Attachments</div>
                      <button type="button" mat-stroked-button placeholder="Add"
                        [disabled]="!eduexpdoceditable || experienceproof.length == 5"
                        [class.delete-button-mobile]="eduexpdoceditable == true && experienceproof.length < 5"
                        (click)="additemToAttachmentExperience()" matTooltip="Add New Attachment" style="margin: 1%;">+
                        Add</button>
                    </div> -->
                    <!-- Row 4  -->
                    <div class="edu-attachment-wrpper">
                      <div formArrayName="experienceproof" fxLayout="row" fxLayoutAlign="center center"
                        *ngFor="let data of onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls']; let i = index">
                        <div class="education-wrapper" fxLayout="column">
                          <div class="attachment-wrapper" [formGroupName]="i"
                            *ngIf="onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').value != 'delete'">
                            <div class="uploaded-file-name ">
                              <div class="uploaded-name education-attach"
                                [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                                fxLayoutAlign="start center" fxLayout="row">
                                <span
                                  *ngIf="onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').value != null && 
                      onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').value != '' && 
                      onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').value != 'delete' &&
                      onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').value != undefined; else edu_other_content1">
                                  <i class="fas fa-file-lines attach-icon"></i>
                                </span>
                                <ng-template #edu_other_content1>
                                  <i class="fas fa-file-lines attach-icon-disable"></i>
                                </ng-template>
                                <div fxLayout="column">
                                  <div class="doc-font-color">
                                    <mat-form-field [ngClass]="!eduexpdoceditable ? 'disabled-field' : ''">
                                      <input class="file-name" matInput placeholder="File Name"
                                        [readonly]="!eduexpdoceditable"
                                        (input)="triggerUniqueNameValidator('experience')" formControlName="filename"
                                        autocomplete="off" maxlength="50">
                                      <!-- Required error -->
                                      <mat-error
                                        *ngIf="onboardCreateForm.get('eduexpattachments').get('experienceproof').at(i).get('filename').hasError('required')">
                                        <strong>Required</strong>
                                      </mat-error>
                                      <!-- Duplicate name error -->
                                      <mat-error
                                        *ngIf="onboardCreateForm.get('eduexpattachments').get('experienceproof').at(i).get('filename').hasError('duplicateName')">
                                        <strong>Duplicate Name</strong>
                                      </mat-error>
                                    </mat-form-field>
                                  </div>
                                  <div class="supported-file input-file">PDF or docx</div>
                                </div>
                              </div>
                            </div>
                            <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                              <span fxLayout="row" fxLayoutAlign="start center">
                                <a class="download-attachment disabled-a" [class.disabled-a]="!eduexpdoceditable"
                                  fxLayout="row" fxLayoutAlign="start center"
                                  (click)="!eduexpdoceditable ? 'javascript:void(0)': fileSample.click()">
                                  <u>Upload</u>
                                  &nbsp;
                                  <span
                                    *ngIf="onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').value != null && 
                        onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').value != '' && 
                        onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').value != 'delete' &&
                        onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').value != undefined;">
                                    <mat-icon class="completed-file-upload"> done</mat-icon>
                                  </span>
                                  &nbsp;
                                  <input type="file" matTooltip="Upload" #fileSample
                                    (change)="fileUploadExperience($event, i);fileSample.value=''" accept=".pdf,.docx">
                                </a>
                                <mat-error class="required-error" matTooltip="Required"
                                  *ngIf="onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').hasError('required') && 
                              onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').touched">
                                  <mat-icon>error</mat-icon>
                                </mat-error>
                              </span>
                              <span>
                                <span
                                  *ngIf="onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').value != null && 
                      onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').value != '' && 
                      onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').value != 'delete' &&
                      onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').value != undefined">
                                  <a class="delete-attachment disabled-a" [class.disabled-a]="!eduexpdoceditable"
                                    (click)="!eduexpdoceditable ? 'javascript:void(0)':deleteAttachmentExperience(i)">
                                    <u>Delete</u> &nbsp;</a>
                                </span>
                                <a class="delete-attachment disabled-a" style="text-align: end;"
                                  [class.disabled-a]="!eduexpdoceditable"
                                  *ngIf="onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').value == null ||
                          onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').value == '' ||
                          onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').value == 'delete' ||
                          onboardCreateForm['controls'].eduexpattachments['controls'].experienceproof['controls'][i].get('filecontent').value == undefined"
                                  (click)="!eduexpdoceditable ? 'javascript:void(0)':deleteAttachmentExperience(i)">
                                  <u>Remove</u> &nbsp;</a>
                              </span>
                            </div>
                          </div>
                        </div>
                        <!-- <div *ngIf="experienceproof.length % 2 === 0" fxFlex="250px" class="edu-exp-container">
                        </div> -->
                      </div>
                    </div>
                  </mat-card>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="end center" style="padding: 0px 15px 10px 10px;">
                <button (click)="downloadAllFilesAsZip()" fxFlexAlign="end" style="padding: 0 15px !important;"
                  [ngClass]="{'disabled-btn': preonboardfilesuploaded === null || preonboardfilesuploaded === undefined || preonboardfilesuploaded === '' || preonboardfilesuploaded.length == 0}"
                  mat-raised-button class="edit-button download-all">
                  <mat-icon>arrow_downward</mat-icon>
                  <span>Download All Files </span>
                </button>
              </div>
            </div>
            <!-- Preboardning Forms Tab  -->
            <!-- *ngIf="orgBasedOnboardFormsJson.formsFieldIsActive" -->
            <!-- [label]="orgBasedOnboardFormsJson.formsFieldDisplayName" -->
            <mat-card class="section-card" *ngIf="formIndex === 6">
              <div class="subtitle-wrapper" fxLayout="row" fxLayoutAlign="space-between center">
                <p class="section-title personal-title">
                  Pre-Boarding Forms
                </p>
                <div fxLayout="row" fxLayoutAlign="end center" class="enter-button-wrapper">
                  <!-- <button mat-raised-button class="edit-button disabled-btn" (click)="downloadOrgbasedPreonboardDocs()">
                    <mat-icon>arrow_downward</mat-icon>
                    <span class="icon-content">Templates</span>
                  </button> -->
                  <button *ngIf="formsdoceditable" (click)="cancelFileEdit('forms'); formsdoceditable=false"
                    mat-raised-button class="edit-button cancel-button">
                    <mat-icon>close</mat-icon>
                    <span class="icon-content">Cancel</span>
                  </button>
                  <button *ngIf="!formsdoceditable" (click)="formsdoceditable = true; enableFileEdit('forms')"
                    mat-raised-button class="edit-button">
                    <!-- *ngIf="!formsdoceditable && ((loggedInUserrole.includes('Recruitmentmanager') && rowInfo.assignedto.toLowerCase() === loggedInUsername.toLowerCase())|| !loggedInUserrole.includes('Recruitmentmanager'))" -->
                    <mat-icon>edit</mat-icon>
                    <span class="icon-content">Edit</span>
                  </button>
                  <button *ngIf="formsdoceditable" mat-raised-button class="edit-button"
                    [disabled]="!onboardCreateForm.get('forms').dirty" (click)="submitFormsAccordion()">
                    <mat-icon>save</mat-icon>
                    <span class="icon-content">Update</span>
                  </button>
                </div>
              </div>
              <div fxLayout="column" fxLayoutGap="3%">
                <div fxLayout="row" fxLayoutAlign="space-around start" class="compensation-attachment-wrpper">
                  <div fxLayout="column" fxLayoutGap="25px">
                    <!-- Confidentiality Form  -->
                    <div class="attachment-wrapper">
                      <div class="uploaded-file-name">
                        <div class="uploaded-name" [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                          fxLayoutAlign="start center" fxLayout="row">
                          <span
                            *ngIf="onboardCreateForm.get('forms').get('confidentialityform').value != null && 
                        onboardCreateForm.get('forms').get('confidentialityform').value != '' && 
                        onboardCreateForm.get('forms').get('confidentialityform').value != 'delete' &&
                        onboardCreateForm.get('forms').get('confidentialityform').value != undefined; else forms_other_content">
                            <i class="fas fa-file-lines attach-icon"></i>
                          </span>
                          <ng-template #forms_other_content>
                            <i class="fas fa-file-lines attach-icon-disable"></i>
                          </ng-template>
                          <!-- {{orgBasedOnboardFormsJson.confidentialityformFieldDisplayName}} -->
                          <div fxLayout="column">
                            <div class="doc-font-color">Confidentiality Form</div>
                            <div class="supported-file">PDF or docx</div>
                          </div>
                        </div>

                      </div>
                      <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                        <a class="download-attachment disabled-a" [class.disabled-a]="!formsdoceditable" fxLayout="row"
                          fxLayoutAlign="start center"
                          (click)="!formsdoceditable ? 'javascript:void(0)': confidentialityform.click()">
                          <u>Upload</u>
                          &nbsp;
                          <span *ngIf="onboardCreateForm.get('forms').get('confidentialityform').value != null && 
                        onboardCreateForm.get('forms').get('confidentialityform').value != '' && 
                        onboardCreateForm.get('forms').get('confidentialityform').value != 'delete' &&
                        onboardCreateForm.get('forms').get('confidentialityform').value != undefined;">
                            <mat-icon class="completed-file-upload"> done</mat-icon>
                          </span>
                          &nbsp;
                          <input type="file" #confidentialityform
                            (change)="fileUpload($event,'forms','confidentialityform');confidentialityform.value=''"
                            accept=".pdf,.docx" required>
                        </a>
                        <!-- Other Files related functions  -->
                        <span *ngIf="onboardCreateForm.get('forms').get('confidentialityform').value != null && 
                        onboardCreateForm.get('forms').get('confidentialityform').value != '' && 
                        onboardCreateForm.get('forms').get('confidentialityform').value != 'delete' &&
                        onboardCreateForm.get('forms').get('confidentialityform').value != undefined">
                          <a class="delete-attachment disabled-a" [class.disabled-a]="!formsdoceditable" (click)="
                        !formsdoceditable ? 'javascript:void(0)':
                        deleteDocumentFile('forms','confidentialityform')">
                            <u>Delete</u>
                            &nbsp;</a>
                        </span>
                      </div>
                    </div>
                    <!-- COI Form  -->
                    <div class="attachment-wrapper">
                      <div class="uploaded-file-name">
                        <div class="uploaded-name" [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                          fxLayoutAlign="start center" fxLayout="row">
                          <span
                            *ngIf="onboardCreateForm.get('forms').get('conflictofinterestform').value != null && 
                        onboardCreateForm.get('forms').get('conflictofinterestform').value != '' && 
                        onboardCreateForm.get('forms').get('conflictofinterestform').value != 'delete' &&
                        onboardCreateForm.get('forms').get('conflictofinterestform').value != undefined; else forms_other_content1">
                            <i class="fas fa-file-lines attach-icon"></i>
                          </span>
                          <ng-template #forms_other_content1>
                            <i class="fas fa-file-lines attach-icon-disable"></i>
                          </ng-template>
                          <!-- {{orgBasedOnboardFormsJson.conflictofintFieldDisplayName}} -->
                          <div fxLayout="column">
                            <div class="doc-font-color">Conflict of Interest</div>
                            <div class="supported-file">PDF or docx</div>
                          </div>
                        </div>
                      </div>
                      <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                        <a class="download-attachment disabled-a" [class.disabled-a]="!formsdoceditable" fxLayout="row"
                          fxLayoutAlign="start center"
                          (click)="!formsdoceditable ? 'javascript:void(0)': conflictofinterestform.click()">
                          <u>Upload</u>
                          &nbsp;
                          <span *ngIf="onboardCreateForm.get('forms').get('conflictofinterestform').value != null && 
                        onboardCreateForm.get('forms').get('conflictofinterestform').value != '' && 
                        onboardCreateForm.get('forms').get('conflictofinterestform').value != 'delete' &&
                        onboardCreateForm.get('forms').get('conflictofinterestform').value != undefined;">
                            <mat-icon class="completed-file-upload"> done</mat-icon>
                          </span>
                          &nbsp;
                          <input type="file" #conflictofinterestform
                            (change)="fileUpload($event,'forms','conflictofinterestform');conflictofinterestform.value=''"
                            accept=".pdf,.docx" required>
                        </a>
                        <!-- Other Files related functions  -->
                        <span *ngIf="onboardCreateForm.get('forms').get('conflictofinterestform').value != null && 
                                onboardCreateForm.get('forms').get('conflictofinterestform').value != '' && 
                                onboardCreateForm.get('forms').get('conflictofinterestform').value != 'delete' &&
                                onboardCreateForm.get('forms').get('conflictofinterestform').value != undefined">
                          <a class="delete-attachment disabled-a" [class.disabled-a]="!formsdoceditable" (click)="
                                !formsdoceditable ? 'javascript:void(0)':
                                deleteDocumentFile('forms','conflictofinterestform')">
                            <u>Delete</u>
                            &nbsp;</a>
                        </span>
                      </div>
                    </div>
                    <!-- Medical Form  -->
                    <div class="attachment-wrapper">
                      <div class="uploaded-file-name">
                        <div class="uploaded-name" [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                          fxLayoutAlign="start center" fxLayout="row">
                          <span
                            *ngIf="onboardCreateForm.get('forms').get('medicalreport').value != null && 
                        onboardCreateForm.get('forms').get('medicalreport').value != '' && 
                        onboardCreateForm.get('forms').get('medicalreport').value != 'delete' &&
                        onboardCreateForm.get('forms').get('medicalreport').value != undefined; else forms_other_content2">
                            <i class="fas fa-file-lines attach-icon"></i>
                          </span>
                          <ng-template #forms_other_content2>
                            <i class="fas fa-file-lines attach-icon-disable"></i>
                          </ng-template>
                          <!-- {{orgBasedOnboardFormsJson.medicalformFieldDisplayName}} -->
                          <div fxLayout="column">
                            <div class="doc-font-color">Medical Form</div>
                            <div class="supported-file">PDF or docx</div>
                          </div>
                        </div>

                      </div>
                      <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                        <a class="download-attachment disabled-a" [class.disabled-a]="!formsdoceditable" fxLayout="row"
                          fxLayoutAlign="start center"
                          (click)="!formsdoceditable ? 'javascript:void(0)': medicalreport.click()">
                          <u>Upload</u>
                          &nbsp;
                          <span *ngIf="onboardCreateForm.get('forms').get('medicalreport').value != null && 
                        onboardCreateForm.get('forms').get('medicalreport').value != '' && 
                        onboardCreateForm.get('forms').get('medicalreport').value != 'delete' &&
                        onboardCreateForm.get('forms').get('medicalreport').value != undefined; ">
                            <mat-icon class="completed-file-upload"> done</mat-icon>
                          </span>
                          &nbsp;
                          <input type="file" #medicalreport
                            (change)="fileUpload($event,'forms','medicalreport');medicalreport.value=''"
                            accept=".pdf,.docx" required>
                        </a>
                        <!-- Other Files related functions  -->
                        <span *ngIf="onboardCreateForm.get('forms').get('medicalreport').value != null && 
                                onboardCreateForm.get('forms').get('medicalreport').value != '' && 
                                onboardCreateForm.get('forms').get('medicalreport').value != 'delete' &&
                                onboardCreateForm.get('forms').get('medicalreport').value != undefined">
                          <a class="delete-attachment disabled-a" [class.disabled-a]="!formsdoceditable" (click)="
                                !formsdoceditable ? 'javascript:void(0)':
                                deleteDocumentFile('forms','medicalreport')">
                            <u>Delete</u>
                            &nbsp;</a>
                        </span>
                      </div>
                    </div>
                    <!-- PF UAN Form  -->
                    <div class="attachment-wrapper">
                      <div class="uploaded-file-name">
                        <div class="uploaded-name" [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                          fxLayoutAlign="start center" fxLayout="row">
                          <span *ngIf="onboardCreateForm.get('forms').get('pfuan').value != null && 
                      onboardCreateForm.get('forms').get('pfuan').value != '' && 
                      onboardCreateForm.get('forms').get('pfuan').value != 'delete' &&
                      onboardCreateForm.get('forms').get('pfuan').value != undefined; else forms_other_content3">
                            <i class="fas fa-file-lines attach-icon"></i>
                          </span>
                          <ng-template #forms_other_content3>
                            <i class="fas fa-file-lines attach-icon-disable"></i>
                          </ng-template>
                          <!-- {{orgBasedOnboardFormsJson.pfformFieldDisplayName}} -->
                          <div fxLayout="column">
                            <div class="doc-font-color">Social Security Form</div>
                            <div class="supported-file">PDF or docx</div>
                          </div>
                        </div>
                      </div>
                      <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                        <a class="download-attachment disabled-a" [class.disabled-a]="!formsdoceditable" fxLayout="row"
                          fxLayoutAlign="start center"
                          (click)="!formsdoceditable ? 'javascript:void(0)': pfuan.click()">
                          <u>Upload</u>
                          &nbsp;
                          <span *ngIf="onboardCreateForm.get('forms').get('pfuan').value != null && 
                        onboardCreateForm.get('forms').get('pfuan').value != '' && 
                        onboardCreateForm.get('forms').get('pfuan').value != 'delete' &&
                        onboardCreateForm.get('forms').get('pfuan').value != undefined; ">
                            <mat-icon class="completed-file-upload"> done</mat-icon>
                          </span>
                          &nbsp;
                          <input type="file" #pfuan (change)="fileUpload($event,'forms','pfuan');pfuan.value=''"
                            accept=".pdf,.docx" required>
                        </a>
                        <!-- Other Files related functions  -->
                        <span *ngIf="onboardCreateForm.get('forms').get('pfuan').value != null && 
                                    onboardCreateForm.get('forms').get('pfuan').value != '' && 
                                    onboardCreateForm.get('forms').get('pfuan').value != 'delete' &&
                                    onboardCreateForm.get('forms').get('pfuan').value != undefined">
                          <a class="delete-attachment disabled-a" [class.disabled-a]="!formsdoceditable" (click)="
                                    !formsdoceditable ? 'javascript:void(0)':
                                    deleteDocumentFile('forms','pfuan')">
                            <u>Delete</u>
                            &nbsp;</a>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div fxLayout="column" fxLayoutGap="25px">
                    <!-- Employment Application Form  -->
                    <div class="attachment-wrapper">
                      <div class="uploaded-file-name">
                        <div class="uploaded-name" [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                          fxLayoutAlign="start center" fxLayout="row">
                          <span
                            *ngIf="onboardCreateForm.get('forms').get('employmentapplicationform').value != null && 
                            onboardCreateForm.get('forms').get('employmentapplicationform').value != '' && 
                            onboardCreateForm.get('forms').get('employmentapplicationform').value != 'delete' &&
                            onboardCreateForm.get('forms').get('employmentapplicationform').value != undefined; else forms_other_content4">
                            <i class="fas fa-file-lines attach-icon"></i>
                          </span>
                          <ng-template #forms_other_content4>
                            <i class="fas fa-file-lines attach-icon-disable"></i>
                          </ng-template>
                          <!-- {{orgBasedOnboardFormsJson.empappformFieldDisplayName}} -->
                          <div fxLayout="column">
                            <div class="doc-font-color">Employment Application form</div>
                            <div class="supported-file">PDF or docx</div>
                          </div>
                        </div>
                      </div>
                      <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                        <a class="download-attachment disabled-a" [class.disabled-a]="!formsdoceditable" fxLayout="row"
                          fxLayoutAlign="start center"
                          (click)="!formsdoceditable ? 'javascript:void(0)': EmploymentAppForm.click()">
                          <u>Upload</u>
                          &nbsp;
                          <span *ngIf="onboardCreateForm.get('forms').get('employmentapplicationform').value != null && 
                            onboardCreateForm.get('forms').get('employmentapplicationform').value != '' && 
                            onboardCreateForm.get('forms').get('employmentapplicationform').value != 'delete' &&
                            onboardCreateForm.get('forms').get('employmentapplicationform').value != undefined;">
                            <mat-icon class="completed-file-upload"> done</mat-icon>
                          </span>
                          &nbsp;
                          <input type="file" #EmploymentAppForm
                            (change)="fileUpload($event,'forms','employmentapplicationform');EmploymentAppForm.value=''"
                            accept=".pdf,.docx" required>
                        </a>
                        <!-- Other Files related functions  -->
                        <span *ngIf="onboardCreateForm.get('forms').get('employmentapplicationform').value != null && 
                                onboardCreateForm.get('forms').get('employmentapplicationform').value != '' && 
                                onboardCreateForm.get('forms').get('employmentapplicationform').value != 'delete' &&
                                onboardCreateForm.get('forms').get('employmentapplicationform').value != undefined">
                          <a class="delete-attachment disabled-a" [class.disabled-a]="!formsdoceditable" (click)="
                                !formsdoceditable ? 'javascript:void(0)':
                                deleteDocumentFile('forms','employmentapplicationform')">
                            <u>Delete</u>
                            &nbsp;</a>
                        </span>
                      </div>
                    </div>
                    <!-- BGV Application Form  -->
                    <div class="attachment-wrapper">
                      <div class="uploaded-file-name">
                        <div class="uploaded-name" [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                          fxLayoutAlign="start center" fxLayout="row">
                          <span
                            *ngIf="onboardCreateForm.get('forms').get('bgvform').value != null && 
                            onboardCreateForm.get('forms').get('bgvform').value != '' && 
                            onboardCreateForm.get('forms').get('bgvform').value != 'delete' &&
                            onboardCreateForm.get('forms').get('bgvform').value != undefined; else forms_other_content5">
                            <i class="fas fa-file-lines attach-icon"></i>
                          </span>
                          <ng-template #forms_other_content5>
                            <i class="fas fa-file-lines attach-icon-disable"></i>
                          </ng-template>
                          <!-- {{orgBasedOnboardFormsJson.bgvformFieldDisplayName}} -->
                          <div fxLayout="column">
                            <div class="doc-font-color">BGV Form</div>
                            <div class="supported-file">PDF or docx</div>
                          </div>
                        </div>

                      </div>
                      <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                        <a class="download-attachment disabled-a" [class.disabled-a]="!formsdoceditable" fxLayout="row"
                          fxLayoutAlign="start center"
                          (click)="!formsdoceditable ? 'javascript:void(0)': bgvform.click()">
                          <u>Upload</u>
                          &nbsp;
                          <span *ngIf="onboardCreateForm.get('forms').get('bgvform').value != null && 
                        onboardCreateForm.get('forms').get('bgvform').value != '' && 
                        onboardCreateForm.get('forms').get('bgvform').value != 'delete' &&
                        onboardCreateForm.get('forms').get('bgvform').value != undefined;">
                            <mat-icon class="completed-file-upload"> done</mat-icon>
                          </span>
                          &nbsp;
                          <input type="file" #bgvform (change)="fileUpload($event,'forms','bgvform');bgvform.value=''"
                            accept=".pdf,.docx" required>
                        </a>
                        <!-- Other Files related functions  -->
                        <span *ngIf="onboardCreateForm.get('forms').get('bgvform').value != null && 
                                onboardCreateForm.get('forms').get('bgvform').value != '' && 
                                onboardCreateForm.get('forms').get('bgvform').value != 'delete' &&
                                onboardCreateForm.get('forms').get('bgvform').value != undefined">
                          <a class="delete-attachment disabled-a" [class.disabled-a]="!formsdoceditable" (click)="
                                !formsdoceditable ? 'javascript:void(0)':
                                deleteDocumentFile('forms','bgvform')">
                            <u>Delete</u>
                            &nbsp;</a>
                        </span>
                      </div>
                    </div>
                    <!-- Joining Form  -->
                    <div class="attachment-wrapper">
                      <div class="uploaded-file-name">
                        <div class="uploaded-name" [ngClass]="currentDisplayLanguage=== 'ar' ? 'arabic-padding' : ''"
                          fxLayoutAlign="start center" fxLayout="row">
                          <span
                            *ngIf="onboardCreateForm.get('forms').get('joiningform').value != null && 
                          onboardCreateForm.get('forms').get('joiningform').value != '' && 
                          onboardCreateForm.get('forms').get('joiningform').value != 'delete' &&
                          onboardCreateForm.get('forms').get('joiningform').value != undefined; else forms_other_content6">
                            <i class="fas fa-file-lines attach-icon"></i>
                          </span>
                          <ng-template #forms_other_content6>
                            <i class="fas fa-file-lines attach-icon-disable"></i>
                          </ng-template>
                          <!-- {{orgBasedOnboardFormsJson.joiningformFieldDisplayName}} -->
                          <div fxLayout="column">
                            <div class="doc-font-color">Joining Form</div>
                            <div class="supported-file">PDF or docx</div>
                          </div>
                        </div>

                      </div>
                      <div fxLayoutAlign="space-between center" fxLayout="row" class="attach-btn-container">
                        <a class="download-attachment disabled-a" [class.disabled-a]="!formsdoceditable" fxLayout="row"
                          fxLayoutAlign="start center"
                          (click)="!formsdoceditable ? 'javascript:void(0)': joiningform.click()">
                          <u>Upload</u>
                          &nbsp;
                          <span *ngIf="onboardCreateForm.get('forms').get('joiningform').value != null && 
                          onboardCreateForm.get('forms').get('joiningform').value != '' && 
                          onboardCreateForm.get('forms').get('joiningform').value != 'delete' &&
                          onboardCreateForm.get('forms').get('joiningform').value != undefined;">
                            <mat-icon class="completed-file-upload"> done</mat-icon>
                          </span>
                          &nbsp;
                          <input type="file" #joiningform
                            (change)="fileUpload($event,'forms','joiningform');joiningform.value=''" accept=".pdf,.docx"
                            required>
                        </a>
                        <!-- Other Files related functions  -->
                        <span *ngIf="onboardCreateForm.get('forms').get('joiningform').value != null && 
                                onboardCreateForm.get('forms').get('joiningform').value != '' && 
                                onboardCreateForm.get('forms').get('joiningform').value != 'delete' &&
                                onboardCreateForm.get('forms').get('joiningform').value != undefined">
                          <a class="delete-attachment disabled-a" [class.disabled-a]="!formsdoceditable" (click)="
                                !formsdoceditable ? 'javascript:void(0)':
                                deleteDocumentFile('forms','joiningform')">
                            <u>Delete</u>
                            &nbsp;</a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br>
            </mat-card>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>